const icons = {
  v3_4dots: () => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="2.5" cy="10.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="10.5" r="2.5" fill="#757575" />
    </svg>
  ),
  v3_continue: () => (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z"
        fill="#757575"
      />
    </svg>
  ),
  plugin: () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="12" height="12" fill="url(#pattern0_2416_753)" />
      <defs>
        <pattern
          id="pattern0_2416_753"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use href="#image0_2416_753" transform="scale(0.00444444)" />
        </pattern>
        <image
          id="image0_2416_753"
          width="225"
          height="225"
          preserveAspectRatio="none"
          href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
  v3_refresh: () => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6856 8.37744L13.6906 8.34182V8.34307C13.7056 8.23182 13.7181 8.11994 13.7269 8.00744C13.7419 7.81869 13.6088 7.50057 13.2588 7.50057C13.0144 7.50057 12.8119 7.68807 12.7919 7.93182C12.7806 8.06994 12.7644 8.20682 12.7431 8.34182C12.34 10.8737 10.1444 12.8124 7.49875 12.8124C5.60063 12.8124 3.93375 11.8143 2.995 10.3156L4.23938 10.3124C4.49813 10.3124 4.70813 10.1024 4.70813 9.84369C4.70813 9.58494 4.49813 9.37494 4.23938 9.37494H1.71875C1.46 9.37494 1.25 9.58494 1.25 9.84369V12.3743C1.25 12.6331 1.46 12.8431 1.71875 12.8431C1.9775 12.8431 2.1875 12.6337 2.1875 12.3743L2.18938 10.7962C3.2925 12.5687 5.25875 13.7499 7.49875 13.7499C10.65 13.7499 13.2594 11.4118 13.6856 8.37744ZM1.32687 6.51869L1.32125 6.55369V6.55244C1.29938 6.69807 1.28188 6.84557 1.27 6.99494C1.255 7.18369 1.38812 7.50182 1.73812 7.50182C1.9825 7.50182 2.185 7.31432 2.205 7.07057C2.21875 6.89557 2.24125 6.72307 2.27188 6.55369C2.71938 4.07369 4.89 2.18994 7.49813 2.18994C9.39625 2.18994 11.0631 3.18807 12.0019 4.68682L10.7575 4.68994C10.4987 4.68994 10.2887 4.89994 10.2887 5.15869C10.2887 5.41744 10.4987 5.62744 10.7575 5.62744H13.2781C13.5369 5.62744 13.7469 5.41744 13.7469 5.15869V2.62807C13.7469 2.36932 13.5369 2.15932 13.2781 2.15932C13.0194 2.15932 12.8094 2.36869 12.8094 2.62807L12.8075 4.20619C11.7044 2.43369 9.73812 1.25244 7.49813 1.25244C4.38312 1.25244 1.79812 3.53619 1.32687 6.51869Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_brain: () => (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.37303 15H1.49458C1.49458 15 1.95335 12.543 1.89022 11.4461C1.86459 10.9936 1.78959 10.5248 1.55271 10.131C1.14956 9.50602 -0.0948628 7.80595 0.00576636 5.4871C0.145772 2.23134 2.93901 0 6.33478 0C9.52116 0 11.6519 1.8757 12.4963 4.67707C12.7013 5.35147 12.6907 5.64023 12.4019 6.30651L12.3982 6.31464L13.4926 7.65344C13.6551 7.89158 13.7507 8.14784 13.7507 8.42785C13.7507 8.76974 13.6051 9.081 13.3694 9.30226C13.1394 9.5179 12.8901 9.58477 12.5894 9.70353C12.5894 9.70353 12.2294 11.3236 12.0438 11.7605C11.6062 12.7874 10.8125 12.7974 10.1874 12.9162C9.94118 12.968 9.88118 12.9993 9.7618 13.3418C9.63179 13.7112 9.53491 14.2387 9.37303 15ZM6.34666 1.24943C3.66842 1.27943 1.50895 2.84199 1.27082 5.3046C1.15081 6.54902 1.56021 7.79595 2.21836 8.87037C2.60025 9.4954 3.03402 9.86541 3.1334 11.2923C3.19027 12.113 3.10215 12.9399 2.98277 13.7499H8.36049C8.44862 13.3468 8.57925 12.8218 8.78988 12.4643C9.07052 11.9855 9.47554 11.7774 9.99368 11.6805C10.5175 11.588 10.7675 11.6436 10.9243 11.1898C11.0569 10.828 11.3069 9.80166 11.4437 8.75099C12.1956 8.54161 11.8263 8.65036 12.4882 8.4016C12.3594 8.25534 11.2894 6.95529 11.21 6.77653C11 6.30214 11.1812 6.03275 11.3506 5.58086C11.4044 5.42398 11.3881 5.35772 11.345 5.19772C10.6893 2.72949 8.91301 1.24943 6.34666 1.24943ZM6.67167 3.12451C6.82293 3.55202 6.86668 3.82578 7.19732 3.96267C7.52858 4.1008 7.75609 3.93516 8.16236 3.74203L8.75801 4.33706C8.563 4.74645 8.39987 4.97208 8.53675 5.3021C8.67363 5.63211 8.94489 5.67586 9.37553 5.82837V6.67028C8.94989 6.82216 8.67363 6.86591 8.53675 7.19718C8.39924 7.52781 8.56362 7.75407 8.75801 8.16221L8.16236 8.75724C7.75171 8.56161 7.52858 8.39847 7.19919 8.53536C6.8673 8.67411 6.82293 8.9485 6.67167 9.37477H5.82913C5.67788 8.94725 5.63413 8.67349 5.30349 8.53723L5.30286 8.5366C4.97222 8.39847 4.74534 8.56348 4.33782 8.75724L3.7428 8.16221C3.93343 7.76032 4.10156 7.53031 3.96343 7.19655C3.82593 6.86591 3.55029 6.82216 3.12527 6.67028V5.82837C3.55091 5.67711 3.82593 5.63336 3.96343 5.30272C4.10094 4.97083 3.93718 4.74582 3.7428 4.33706L4.33782 3.74203C4.74846 3.93704 4.97222 4.10017 5.30286 3.96267C5.6335 3.82578 5.67788 3.54952 5.82913 3.12451H6.67167ZM6.2504 7.29155C5.67538 7.29155 5.20848 6.82528 5.20848 6.24963C5.20848 5.67399 5.67538 5.20772 6.2504 5.20772C6.82543 5.20772 7.2917 5.67399 7.2917 6.24963C7.2917 6.82528 6.82543 7.29155 6.2504 7.29155Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_copy: () => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1126_3135)">
        <rect width="21" height="21" fill="#F1F1F1" />
        <path
          d="M16.75 6.75V16.75H6.75V6.75H16.75ZM18 5.5H5.5V18H18V5.5ZM3 16.125V3H16.125V4.25H4.25V16.125H3Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_1126_3135">
          <rect width="21" height="21" rx="3.75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  v3_filter: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2293 11.8516C10.2293 11.5756 10.0053 11.3516 9.72931 11.3516H6.28931C6.01331 11.3516 5.78931 11.5756 5.78931 11.8516C5.78931 12.1276 6.01331 12.3516 6.28931 12.3516H9.72931C10.0053 12.3516 10.2293 12.1276 10.2293 11.8516ZM11.7 9.1849C11.7 8.9089 11.476 8.6849 11.2 8.6849H4.80265C4.52665 8.6849 4.30265 8.9089 4.30265 9.1849C4.30265 9.4609 4.52665 9.6849 4.80265 9.6849H11.2C11.476 9.6849 11.7 9.4609 11.7 9.1849ZM13.3333 6.51823C13.3333 6.24223 13.1093 6.01823 12.8333 6.01823H3.16665C2.89065 6.01823 2.66665 6.24223 2.66665 6.51823C2.66665 6.79423 2.89065 7.01823 3.16665 7.01823H12.8333C13.1093 7.01823 13.3333 6.79423 13.3333 6.51823ZM14.6666 3.85156C14.6666 3.57556 14.4426 3.35156 14.1666 3.35156H1.83331C1.55731 3.35156 1.33331 3.57556 1.33331 3.85156C1.33331 4.12756 1.55731 4.35156 1.83331 4.35156H14.1666C14.4426 4.35156 14.6666 4.12756 14.6666 3.85156Z"
        fill="#757575"
      />
    </svg>
  ),
  pintask: (props) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.986"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.17475 0C8.2614 0 8.34802 0 8.43467 0C9.60614 1.12679 10.7679 2.26741 11.92 3.42188C12.0074 3.5456 12.0232 3.6784 11.9673 3.82031C11.5796 4.22309 11.1228 4.31684 10.5968 4.10156C9.597 5.24953 8.5967 6.39797 7.59583 7.54688C7.70646 7.72118 7.80098 7.90868 7.87938 8.10938C8.03659 8.7086 7.89086 9.22031 7.44224 9.64453C7.31672 9.71972 7.19068 9.71972 7.06417 9.64453C6.42192 9.00359 5.77604 8.36686 5.12656 7.73438C4.28739 8.56284 3.4446 9.38705 2.59822 10.207C1.89772 10.828 1.18096 11.4256 0.447953 12C0.361311 12 0.274672 12 0.18803 12C-0.0502457 11.8054 -0.0620603 11.5944 0.152586 11.3672C0.654688 10.7441 1.17453 10.1347 1.71212 9.53906C2.57393 8.66081 3.44427 7.78971 4.32316 6.92578C3.64186 6.25001 2.96053 5.57421 2.27923 4.89844C2.20046 4.76562 2.20046 4.63282 2.27923 4.5C2.6891 4.0887 3.18137 3.94416 3.75606 4.06641C3.98274 4.12605 4.18359 4.23152 4.35861 4.38281C5.52873 3.39616 6.69444 2.40398 7.85575 1.40625C7.6946 1.01431 7.71823 0.631498 7.92664 0.257812C7.99824 0.1595 8.08094 0.0735623 8.17475 0Z"
        fill="#757575"
      />
    </svg>
  ),
  taskchatIcon: (props) => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="2.5" cy="10.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="10.5" r="2.5" fill="#757575" />
    </svg>
  ),
  aichatIcon: (props) => (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 3.33267C8.93 3.82 10.18 5.07067 10.666 6.66667C11.1547 5.07 12.4047 3.82067 14 3.33333C12.4047 2.846 11.1547 1.59667 10.666 0C10.18 1.596 8.93 2.84533 7.33333 3.33267ZM12 7.99933C12.958 8.29133 13.708 9.042 13.9993 10C14.2927 9.042 15.0427 8.292 16 8C15.0427 7.70733 14.2927 6.958 13.9993 6C13.708 6.95733 12.958 7.70733 12 7.99933ZM8 11.6667C8.79867 11.91 9.42333 12.5353 9.666 13.3333C9.91 12.5347 10.5353 11.91 11.3333 11.6667C10.5353 11.4227 9.91067 10.7987 9.666 10C9.42333 10.798 8.79867 11.4227 8 11.6667ZM3.99933 3.33333C3.416 5.24867 1.914 6.75 0 7.334C1.91733 7.92067 3.416 9.41933 4.00267 11.3367C4.586 9.42067 6.088 7.92067 8 7.334C6.088 6.75133 4.586 5.24933 3.99933 3.33333Z"
        fill="#757575"
      />
    </svg>
  ),
  aichatIconInput: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 3.33267C8.93 3.82 10.18 5.07067 10.666 6.66667C11.1547 5.07 12.4047 3.82067 14 3.33333C12.4047 2.846 11.1547 1.59667 10.666 0C10.18 1.596 8.93 2.84533 7.33333 3.33267ZM12 7.99933C12.958 8.29133 13.708 9.042 13.9993 10C14.2927 9.042 15.0427 8.292 16 8C15.0427 7.70733 14.2927 6.958 13.9993 6C13.708 6.95733 12.958 7.70733 12 7.99933ZM8 11.6667C8.79867 11.91 9.42333 12.5353 9.666 13.3333C9.91 12.5347 10.5353 11.91 11.3333 11.6667C10.5353 11.4227 9.91067 10.7987 9.666 10C9.42333 10.798 8.79867 11.4227 8 11.6667ZM3.99933 3.33333C3.416 5.24867 1.914 6.75 0 7.334C1.91733 7.92067 3.416 9.41933 4.00267 11.3367C4.586 9.42067 6.088 7.92067 8 7.334C6.088 6.75133 4.586 5.24933 3.99933 3.33333Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_search: (props) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6467 11.354C9.66066 12.1793 8.39066 12.6773 7.00599 12.6773C3.87466 12.6773 1.33333 10.136 1.33333 7.00531C1.33333 3.87465 3.87466 1.33331 7.00599 1.33331C10.136 1.33331 12.678 3.87465 12.678 7.00531C12.678 8.39065 12.18 9.66131 11.3547 10.646L14.5207 13.8126C14.618 13.91 14.6667 14.038 14.6667 14.1666C14.6667 14.558 14.3087 14.6666 14.1667 14.6666C14.0387 14.6666 13.9107 14.618 13.8127 14.52L10.6467 11.354ZM7.00599 2.33398C4.42733 2.33398 2.33466 4.42731 2.33466 7.00531C2.33466 9.58331 4.42733 11.6766 7.00599 11.6766C9.58333 11.6766 11.6773 9.58331 11.6773 7.00531C11.6773 4.42731 9.58333 2.33398 7.00599 2.33398Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
    </svg>
  ),
  uploadimgIcon: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.00781 0C4.15312 0 4.22813 0.028125 4.32656 0.126563C4.43906 0.239063 4.4625 0.314062 4.50469 0.65625C4.52812 0.876562 4.57969 1.17188 4.62187 1.3125C4.66406 1.45312 4.77188 1.71563 4.86563 1.89844C4.97813 2.11406 5.15625 2.34844 5.39062 2.58281C5.59688 2.78906 5.86875 3.00469 6.04688 3.10312C6.21562 3.19687 6.45937 3.30469 6.58594 3.34688C6.71719 3.38906 7.02188 3.45 7.27031 3.47812C7.59844 3.525 7.74844 3.5625 7.82344 3.63281C7.87969 3.68438 7.94531 3.79688 7.96875 3.88125C8.00625 3.99375 7.99687 4.07344 7.94531 4.19531C7.90781 4.28438 7.81875 4.3875 7.74375 4.425C7.67344 4.45781 7.46719 4.5 7.28906 4.51406C7.11094 4.53281 6.81094 4.58906 6.63281 4.64531C6.45469 4.69687 6.16875 4.82344 6 4.92188C5.83125 5.02031 5.57812 5.2125 5.4375 5.34844C5.29688 5.48906 5.10469 5.70937 5.02031 5.83594C4.93125 5.9625 4.80938 6.17812 4.75313 6.30469C4.69688 6.43125 4.61719 6.69375 4.575 6.88125C4.53281 7.06406 4.5 7.30781 4.5 7.41562C4.5 7.53281 4.4625 7.67812 4.40625 7.76719C4.34531 7.86562 4.25156 7.94063 4.14844 7.96875C4.02187 8.00625 3.94688 7.99687 3.82031 7.94531C3.73125 7.90781 3.62812 7.82812 3.59062 7.76719C3.55312 7.71094 3.51094 7.51406 3.49219 7.33594C3.47813 7.15781 3.44063 6.91406 3.4125 6.79688C3.38438 6.67969 3.27656 6.40781 3.17344 6.1875C3.01875 5.87344 2.90156 5.70937 2.60156 5.41406C2.30625 5.11406 2.14219 4.99688 1.82812 4.84219C1.60781 4.73906 1.32187 4.62656 1.19531 4.59375C1.06406 4.56563 0.801562 4.51875 0.609375 4.5C0.31875 4.4625 0.234375 4.43438 0.126563 4.32656C0.028125 4.22344 0 4.15312 0 4.00781C0 3.90469 0.0375 3.77813 0.084375 3.72188C0.126562 3.67031 0.20625 3.60469 0.257812 3.57656C0.309375 3.54844 0.478125 3.51562 0.632812 3.49687C0.7875 3.47812 1.02188 3.44063 1.14844 3.4125C1.27969 3.38438 1.51875 3.3 1.6875 3.225C1.85625 3.15 2.11875 2.99531 2.27344 2.8875C2.42812 2.775 2.625 2.60156 2.71406 2.50313C2.80313 2.40469 2.94844 2.20312 3.0375 2.0625C3.13125 1.92188 3.24844 1.67813 3.30937 1.52344C3.36562 1.36875 3.43594 1.06406 3.46406 0.84375C3.49219 0.623438 3.52969 0.398437 3.53906 0.3375C3.55312 0.28125 3.61875 0.182812 3.68906 0.117188C3.78281 0.0328125 3.87656 0 4.00781 0ZM14.1797 1.5C20.6859 1.5 22.2891 1.51406 22.4766 1.56094C22.6031 1.59844 22.8234 1.6875 22.9641 1.7625C23.1 1.8375 23.3156 2.00156 23.4375 2.13281C23.5594 2.25938 23.7094 2.47031 23.775 2.60156C23.8406 2.72813 23.9203 2.94844 23.9484 3.07969C23.9859 3.25781 24 5.95312 24 12.75C24 19.5469 23.9859 22.2422 23.9484 22.4203C23.9203 22.5516 23.8406 22.7672 23.775 22.8984C23.7094 23.025 23.5594 23.2359 23.4422 23.3625C23.325 23.4844 23.1422 23.6391 23.0391 23.7C22.9359 23.7609 22.7344 23.8547 22.5938 23.9062C22.3359 24 22.2656 24 12.75 24C3.23438 24 3.16406 24 2.90625 23.9062C2.76562 23.8547 2.56406 23.7609 2.46094 23.7C2.35781 23.6391 2.175 23.4844 2.05781 23.3625C1.94063 23.2359 1.79531 23.0391 1.73438 22.9219C1.67344 22.8047 1.59844 22.6031 1.56563 22.4766C1.51406 22.2844 1.5 20.7563 1.5 14.1891C1.5 6.60938 1.50469 6.13125 1.57969 6C1.62656 5.925 1.71094 5.84062 1.76719 5.8125C1.82813 5.78906 1.95 5.76562 2.03906 5.76562C2.16094 5.76562 2.24062 5.80312 2.48438 6.04688V10.8609C2.48438 13.5141 2.49844 15.6984 2.51719 15.7172C2.54063 15.7359 4.00781 14.3016 5.78906 12.525C8.55 9.76875 9.07031 9.26719 9.32812 9.12656C9.49687 9.0375 9.75 8.925 9.89062 8.87812C10.0875 8.8125 10.2891 8.78906 10.7344 8.78906C11.2312 8.78906 11.3719 8.80781 11.6719 8.90625C11.8641 8.96719 12.15 9.10313 12.3047 9.20156C12.4922 9.32344 13.5938 10.3875 18.4922 15.2812L23.0156 10.7578V7.11094C23.0156 4.45312 23.0016 3.40781 22.9594 3.24375C22.9219 3.08906 22.8422 2.9625 22.6922 2.80781C22.5375 2.65781 22.4109 2.57812 22.2562 2.54063C22.0875 2.49844 20.0578 2.48438 6.04688 2.48438L5.90625 2.34375C5.80312 2.24062 5.76562 2.16094 5.76562 2.03906C5.76562 1.95 5.78906 1.82813 5.8125 1.76719C5.84062 1.71094 5.92031 1.62656 5.99063 1.58437C6.10781 1.50937 6.62812 1.50469 14.1797 1.5ZM3.82031 2.70469C3.72187 2.85469 3.49219 3.12656 3.30937 3.30469C3.12656 3.4875 2.85 3.71719 2.69531 3.81563C2.54063 3.91406 2.4375 4.00781 2.46094 4.02656C2.48906 4.04531 2.62969 4.14375 2.78438 4.24219C2.93438 4.34531 3.21094 4.58906 3.39375 4.78125C3.58125 4.97344 3.7875 5.23125 3.85781 5.35312L3.98438 5.57812C4.28438 5.12344 4.51406 4.85156 4.68281 4.68281C4.85156 4.51406 5.12344 4.28906 5.28281 4.19063L5.56875 4.00781C5.12344 3.70781 4.85625 3.48281 4.69219 3.32344C4.52812 3.15938 4.30312 2.89219 4.19531 2.72813L3.99844 2.4375L3.82031 2.70469ZM9.9375 9.94219C9.65156 10.0688 9.40313 10.3078 6.06094 13.65L2.48438 17.2219C2.48438 21.3234 2.50313 22.0922 2.54063 22.2516C2.58281 22.4109 2.65781 22.5328 2.8125 22.6875C2.9625 22.8422 3.08906 22.9172 3.24844 22.9547C3.41719 22.9969 5.7375 23.0109 12.75 23.0109C19.7672 23.0109 22.0875 22.9969 22.2562 22.9547C22.4156 22.9172 22.5375 22.8422 22.6922 22.6875C22.8422 22.5328 22.9219 22.4109 22.9594 22.2516C22.9922 22.1297 23.0156 21.8438 23.0156 21.6188V21.2062C14.0297 12.2297 11.85 10.0875 11.7188 10.0125C11.6062 9.94688 11.3813 9.85781 11.2266 9.82031C11.0719 9.77812 10.8422 9.75 10.7109 9.75469C10.5844 9.75469 10.425 9.76875 10.3594 9.78281C10.2984 9.79219 10.1062 9.86719 9.9375 9.94219ZM19.2188 16.0031C22.1063 18.8953 22.9641 19.7203 22.9828 19.6969C23.0016 19.6781 23.0203 18 23.0203 15.9703C23.0156 13.9406 23.0016 12.2766 22.9828 12.2766C22.9641 12.2766 22.1062 13.1156 21.0844 14.1422L19.2188 16.0031ZM17.9766 3.51094C18.1828 3.51094 18.4781 3.54375 18.6328 3.58125C18.7875 3.62344 19.0406 3.72187 19.1953 3.80625C19.35 3.89062 19.6031 4.08281 19.7578 4.2375C19.9125 4.39219 20.1047 4.64531 20.1891 4.8C20.2688 4.95469 20.3719 5.20781 20.4094 5.3625C20.4516 5.51719 20.4844 5.80313 20.4844 5.99531C20.4844 6.1875 20.4516 6.47344 20.4094 6.62812C20.3719 6.78281 20.2688 7.03594 20.1891 7.19062C20.1047 7.34531 19.9125 7.59844 19.7578 7.75312C19.6031 7.90781 19.35 8.1 19.1953 8.18438C19.0406 8.26406 18.7875 8.36719 18.6328 8.40469C18.4781 8.44688 18.1922 8.47969 18 8.47969C17.8031 8.47969 17.5219 8.44688 17.3672 8.40469C17.2125 8.36719 16.9594 8.26406 16.8047 8.18438C16.65 8.1 16.3969 7.90781 16.2422 7.75312C16.0875 7.59844 15.8906 7.34531 15.8109 7.19062C15.7266 7.03594 15.6281 6.78281 15.5859 6.62812C15.5484 6.47344 15.5156 6.1875 15.5156 5.99531C15.5156 5.80313 15.5484 5.51719 15.5859 5.3625C15.6281 5.20781 15.7266 4.95469 15.8109 4.8C15.8906 4.64531 16.0875 4.39219 16.2422 4.2375C16.3969 4.08281 16.65 3.88594 16.8047 3.80625C16.9594 3.72187 17.1984 3.62344 17.3438 3.58594C17.4844 3.54844 17.7703 3.51563 17.9766 3.51094ZM17.3203 4.65938C17.2172 4.71094 17.0484 4.8375 16.9406 4.94063C16.8375 5.04375 16.7016 5.23125 16.6406 5.3625C16.5469 5.55469 16.5281 5.67188 16.5234 5.99531C16.5234 6.36094 16.5375 6.41719 16.6875 6.69375C16.7766 6.85781 16.9125 7.04531 16.9922 7.11094C17.0672 7.17187 17.2359 7.27969 17.3672 7.34531C17.5641 7.44844 17.6625 7.46719 18 7.46719C18.3375 7.46719 18.4312 7.44844 18.6328 7.34531C18.7594 7.27969 18.9281 7.17187 19.0078 7.11094C19.0828 7.04531 19.2188 6.85781 19.3125 6.69375C19.4625 6.41719 19.4719 6.36094 19.4719 5.99531C19.4719 5.65781 19.4531 5.55938 19.35 5.3625C19.2844 5.23125 19.1766 5.0625 19.1109 4.9875C19.05 4.90781 18.8719 4.77656 18.7219 4.69219C18.5062 4.575 18.3703 4.5375 18.1172 4.51875C17.9344 4.50938 17.7234 4.51406 17.6484 4.5375C17.5688 4.55625 17.4234 4.6125 17.3203 4.65938Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  vectorfilev3: (props) => (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2833 0C19.6385 0 21.5509 1.91236 21.5509 4.26764C21.5509 4.69855 21.4931 6.12655 20.2473 7.33636L11.0127 16.5709C10.3625 17.3029 8.7 17.9662 7.41382 16.6789C6.12873 15.3949 6.77455 13.7498 7.50982 13.0898L12.3196 8.28L13.0909 9.05127L9.63927 12.5018L9.65455 12.5051L8.11527 14.0465L8.11964 14.0498C7.06145 15.3055 8.79382 17.2462 10.2764 15.7647L19.4215 6.61855C20.1371 5.90727 20.4469 5.09891 20.4469 4.26764C20.4469 2.52109 19.0298 1.104 17.2833 1.104C16.4291 1.104 15.6524 1.44327 15.0818 1.99636L15.0785 1.99309C14.4535 2.61818 2.53091 14.532 2.496 14.568L2.49382 14.5658C1.62655 15.4516 1.09091 16.6636 1.09091 18C1.09091 20.7087 3.29127 22.9091 6 22.9091C6.70909 22.9091 8.00727 22.9167 9.84 21.0895L21.0469 9.88909L21.8182 10.6604L10.3887 22.0898C9.29345 23.2647 7.73236 24 6 24C2.68909 24 0 21.3109 0 18C0 16.2796 0.726545 14.7273 1.88836 13.632C13.5262 1.99527 13.7084 1.80764 14.2102 1.308C14.5124 1.00473 15.5356 0 17.2833 0Z"
        fill="#C4C4C4"
      />
    </svg>
  ),
  tooglesidebar: (props) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2277 20.9945H3.77228C3.03748 20.9931 2.33321 20.7007 1.81363 20.1814C1.29405 19.6621 1.0015 18.9582 1 18.2238V3.77657C1.0015 3.04219 1.29405 2.33832 1.81363 1.81903C2.33321 1.29975 3.03748 1.00735 3.77228 1.00586H18.2277C18.9625 1.00735 19.6668 1.29975 20.1864 1.81903C20.7059 2.33832 20.9985 3.04219 21 3.77657V18.2238C20.9985 18.9582 20.7059 19.6621 20.1864 20.1814C19.6668 20.7007 18.9625 20.9931 18.2277 20.9945ZM3.77228 2.13676C3.33713 2.13676 2.9198 2.30953 2.6121 2.61705C2.3044 2.92457 2.13154 3.34166 2.13154 3.77657V18.2238C2.13154 18.6587 2.3044 19.0758 2.6121 19.3834C2.9198 19.6909 3.33713 19.8636 3.77228 19.8636H18.2277C18.6629 19.8636 19.0802 19.6909 19.3879 19.3834C19.6956 19.0758 19.8685 18.6587 19.8685 18.2238V3.77657C19.8685 3.34166 19.6956 2.92457 19.3879 2.61705C19.0802 2.30953 18.6629 2.13676 18.2277 2.13676H3.77228Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
      <path
        d="M7.32236 20.5C7.30483 20.5 7.28807 20.493 7.27576 20.4807C7.26345 20.4684 7.25659 20.4518 7.25659 20.4345V1.56545C7.25659 1.54818 7.26345 1.53157 7.27576 1.51927C7.28807 1.50696 7.30483 1.5 7.32236 1.5C7.3399 1.5 7.35666 1.50696 7.36897 1.51927C7.38127 1.53157 7.38813 1.54818 7.38813 1.56545V20.4345C7.38813 20.4518 7.38127 20.4684 7.36897 20.4807C7.35665 20.493 7.33989 20.5 7.32236 20.5Z"
        fill="#757575"
        stroke="#757575"
      />
    </svg>
  ),
  spinner: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="4"
        stroke={props.color ? props.color : "#000"}
        stroke-linecap="round"
        stroke-dasharray="90,150"
        stroke-dashoffset="0"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  newchatIcon: (props) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5238 8.41497C20.4104 8.41497 20.3016 8.46002 20.2215 8.54021C20.1413 8.6204 20.0962 8.72916 20.0962 8.84257V19.0466C20.0962 19.3199 19.9877 19.5819 19.7945 19.7751C19.6013 19.9682 19.3393 20.0768 19.0661 20.0768H2.89018C2.61698 20.0768 2.35496 19.9682 2.16178 19.7751C1.96859 19.5819 1.86006 19.3199 1.86006 19.0466V2.89018C1.86006 2.61698 1.96859 2.35496 2.16178 2.16178C2.35496 1.96859 2.61698 1.86006 2.89018 1.86006H13.0943C13.2083 1.86006 13.3177 1.81475 13.3983 1.73411C13.479 1.65346 13.5243 1.54408 13.5243 1.43003C13.5243 1.31598 13.479 1.2066 13.3983 1.12595C13.3177 1.04531 13.2083 1 13.0943 1H2.89018C2.38888 1 1.9081 1.19914 1.55362 1.55362C1.19914 1.9081 1 2.38888 1 2.89018V19.0612C1 19.5625 1.19914 20.0433 1.55362 20.3978C1.9081 20.7523 2.38888 20.9514 2.89018 20.9514H19.0612C19.5625 20.9514 20.0433 20.7523 20.3978 20.3978C20.7523 20.0433 20.9514 19.5625 20.9514 19.0612V8.85714C20.9534 8.79977 20.9438 8.7426 20.9231 8.68903C20.9025 8.63545 20.8713 8.58658 20.8314 8.54532C20.7915 8.50405 20.7437 8.47125 20.6909 8.44885C20.638 8.42646 20.5812 8.41493 20.5238 8.41497Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.5"
      />
      <path
        d="M18.9932 1.10945L18.9831 1.10847L18.973 1.10954C18.71 1.13748 18.4551 1.21744 18.2233 1.34478C17.9931 1.4712 17.7902 1.64181 17.6261 1.8468L10.7253 8.7476L10.725 8.74731L10.7192 8.7543L10.695 8.78329C10.695 8.78331 10.695 8.78334 10.695 8.78337C10.5923 8.90603 10.4541 9.15839 10.303 9.46716C10.1499 9.77996 9.97834 10.162 9.80952 10.5528C9.47203 11.3342 9.14381 12.1548 8.99289 12.5369C8.95318 12.6331 8.94281 12.7389 8.96309 12.841C8.98343 12.9434 9.03369 13.0375 9.10751 13.1113C9.18133 13.1851 9.27538 13.2354 9.37777 13.2557C9.47987 13.276 9.58568 13.2656 9.68189 13.2259C10.0641 13.075 10.8834 12.7467 11.6642 12.4093C12.0547 12.2404 12.4366 12.0689 12.7496 11.9158C13.0587 11.7647 13.3114 11.6265 13.4351 11.5241L13.4353 11.5239L13.4645 11.4996L13.4648 11.4999L13.4712 11.4934L20.3677 4.58725C20.7441 4.27634 21.002 3.84537 21.0981 3.36667L21.1003 3.35589L21.1001 3.34489C21.094 3.05503 21.025 2.76995 20.8978 2.50941C20.7721 2.25191 20.5926 2.02446 20.3714 1.84244C20.202 1.63727 19.9942 1.46712 19.7595 1.34157C19.5219 1.21443 19.2615 1.13554 18.9932 1.10945ZM19.6312 3.82719L19.6307 3.82664L19.6223 3.83507L12.7427 10.7147C11.9933 11.1121 11.2216 11.4656 10.4313 11.7735C10.742 10.9829 11.0986 10.211 11.4991 9.46169L18.3836 2.59172L18.3837 2.59165C18.5426 2.43272 18.666 2.32521 18.7665 2.25779C18.8673 2.19025 18.9363 2.16904 18.9884 2.16904C19.0408 2.16904 19.1248 2.19521 19.2398 2.26689C19.3524 2.33701 19.4849 2.44458 19.632 2.59165C19.7802 2.73985 19.8959 2.87597 19.9698 2.99333C20.0432 3.10992 20.064 3.19012 20.0575 3.23888C19.9728 3.47073 19.8252 3.67448 19.6312 3.82719Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
    </svg>
  ),
  pencilblack: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_715_7299)">
        <path
          d="M1.5 10.3501L0 15.0001L4.65 13.5001L1.5 10.3501Z"
          fill="#5D737E"
        />
        <path
          d="M9.87192 1.9538L2.5535 9.27222L5.73543 12.4541L13.0538 5.13572L9.87192 1.9538Z"
          fill="#5D737E"
        />
        <path
          d="M14.775 2.325L12.675 0.225C12.375 -0.075 11.925 -0.075 11.625 0.225L10.95 0.9L14.1 4.05L14.775 3.375C15.075 3.075 15.075 2.625 14.775 2.325Z"
          fill="#5D737E"
        />
      </g>
      <defs>
        <clipPath id="clip0_715_7299">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  magicstar: (props) => (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5417 4.79071C12.8369 5.49125 14.6337 7.28908 15.3324 9.58333C16.0348 7.28813 17.8317 5.49221 20.125 4.79167C17.8317 4.09113 16.0348 2.29521 15.3324 0C14.6337 2.29425 12.8369 4.09017 10.5417 4.79071ZM17.25 11.499C18.6271 11.9188 19.7052 12.9979 20.124 14.375C20.5457 12.9979 21.6238 11.9198 23 11.5C21.6238 11.0793 20.5457 10.0021 20.124 8.625C19.7052 10.0012 18.6271 11.0793 17.25 11.499ZM11.5 16.7708C12.6481 17.1206 13.546 18.0195 13.8949 19.1667C14.2456 18.0186 15.1445 17.1206 16.2917 16.7708C15.1445 16.4201 14.2466 15.5231 13.8949 14.375C13.546 15.5221 12.6481 16.4201 11.5 16.7708ZM5.74904 4.79167C4.9105 7.54496 2.75138 9.70312 0 10.5426C2.75617 11.386 4.9105 13.5403 5.75383 16.2965C6.59238 13.5422 8.7515 11.386 11.5 10.5426C8.7515 9.70504 6.59238 7.54592 5.74904 4.79167Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  shared: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
    >
      <path
        d="M2.7 6.44314C3.69281 6.44314 4.5 5.6176 4.5 4.60223C4.5 3.58685 3.69281 2.76132 2.7 2.76132C1.70719 2.76132 0.9 3.58685 0.9 4.60223C0.9 5.6176 1.70719 6.44314 2.7 6.44314ZM15.3 6.44314C16.2928 6.44314 17.1 5.6176 17.1 4.60223C17.1 3.58685 16.2928 2.76132 15.3 2.76132C14.3072 2.76132 13.5 3.58685 13.5 4.60223C13.5 5.6176 14.3072 6.44314 15.3 6.44314ZM16.2 7.36359H14.4C13.905 7.36359 13.4578 7.56782 13.1316 7.89861C14.265 8.5343 15.0694 9.68199 15.2437 11.0454H17.1C17.5978 11.0454 18 10.6341 18 10.125V9.2045C18 8.18912 17.1928 7.36359 16.2 7.36359ZM9 7.36359C10.7409 7.36359 12.15 5.92251 12.15 4.142C12.15 2.3615 10.7409 0.92041 9 0.92041C7.25906 0.92041 5.85 2.3615 5.85 4.142C5.85 5.92251 7.25906 7.36359 9 7.36359ZM11.16 8.28405H10.9266C10.3416 8.57169 9.69187 8.74427 9 8.74427C8.30812 8.74427 7.66125 8.57169 7.07344 8.28405H6.84C5.05125 8.28405 3.6 9.76828 3.6 11.5977V12.4261C3.6 13.1883 4.20469 13.8068 4.95 13.8068H13.05C13.7953 13.8068 14.4 13.1883 14.4 12.4261V11.5977C14.4 9.76828 12.9487 8.28405 11.16 8.28405ZM4.86844 7.89861C4.54219 7.56782 4.095 7.36359 3.6 7.36359H1.8C0.807187 7.36359 0 8.18912 0 9.2045V10.125C0 10.6341 0.402187 11.0454 0.9 11.0454H2.75344C2.93062 9.68199 3.735 8.5343 4.86844 7.89861Z"
        fill="#92A5AF"
      />
    </svg>
  ),
  filledStar: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M7.54894 0.927052C7.8483 0.0057416 9.1517 0.00573945 9.45106 0.92705L10.6329 4.56434C10.7668 4.97636 11.1507 5.25532 11.5839 5.25532H15.4084C16.3771 5.25532 16.7799 6.49494 15.9962 7.06434L12.9021 9.31231C12.5516 9.56695 12.405 10.0183 12.5389 10.4303L13.7207 14.0676C14.02 14.9889 12.9656 15.7551 12.1818 15.1857L9.08779 12.9377C8.7373 12.6831 8.2627 12.6831 7.91222 12.9377L4.81815 15.1857C4.03444 15.7551 2.97996 14.9889 3.27931 14.0676L4.46114 10.4303C4.59501 10.0183 4.44835 9.56695 4.09787 9.31231L1.00381 7.06434C0.220092 6.49494 0.622867 5.25532 1.59159 5.25532H5.41606C5.84929 5.25532 6.23324 4.97636 6.36712 4.56434L7.54894 0.927052Z"
        fill="#F6CF00"
      />
    </svg>
  ),
  star: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.02447 1.08156C8.17415 0.620902 8.82585 0.620907 8.97553 1.08156L10.1574 4.71885C10.3582 5.33688 10.9341 5.75532 11.5839 5.75532H15.4084C15.8928 5.75532 16.0942 6.37513 15.7023 6.65983L12.6082 8.9078C12.0825 9.28976 11.8625 9.96681 12.0633 10.5848L13.2452 14.2221C13.3948 14.6828 12.8676 15.0659 12.4757 14.7812L9.38168 12.5332C8.85595 12.1512 8.14405 12.1512 7.61832 12.5332L4.52426 14.7812C4.1324 15.0659 3.60516 14.6828 3.75484 14.2221L4.93667 10.5848C5.13748 9.96682 4.91749 9.28976 4.39176 8.9078L1.2977 6.65983C0.90584 6.37513 1.10723 5.75532 1.59159 5.75532H5.41606C6.0659 5.75532 6.64183 5.33688 6.84265 4.71885L8.02447 1.08156Z"
        stroke="#92A5AF"
      />
    </svg>
  ),
  pencil: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_426_7269)">
        <path d="M2 13.7998L0 19.9998L6.2 17.9998L2 13.7998Z" fill="#FCFCFC" />
        <path
          d="M13.1627 2.6049L3.40479 12.3628L7.64736 16.6054L17.4053 6.84747L13.1627 2.6049Z"
          fill="#FCFCFC"
        />
        <path
          d="M19.7001 3.1L16.9001 0.3C16.5001 -0.1 15.9001 -0.1 15.5001 0.3L14.6001 1.2L18.8001 5.4L19.7001 4.5C20.1001 4.1 20.1001 3.5 19.7001 3.1Z"
          fill="#FCFCFC"
        />
      </g>
      <defs>
        <clipPath id="clip0_426_7269">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  attach: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"
      ></path>
    </svg>
  ),
  dobuleTickWhite: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M0 5.38285L3.08199 9.5L9 1.61716L8.15037 0.5L3.08199 7.24996L0.83786 4.25782L0 5.38285Z"
        fill="#FCFCFC"
      />
      <path
        d="M7 5.38285L10.08199 9.5L16 1.61716L15.15037 0.5L10.08199 7.24996L7.83786 4.25782L7 5.38285Z"
        fill="#FCFCFC"
      />
    </svg>
  ),
  close: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="14"
      height="14"
      viewBox="0,0,256,256"
    >
      <g
        fill-opacity="0.8"
        fill="#000000"
        fillRule="nonzero"
        stroke="none"
        stroke-width="1"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke-miterlimit="10"
        stroke-dasharray=""
        stroke-dashoffset="0"
        font-family="none"
        font-weight="none"
        font-size="none"
        text-anchor="none"
      >
        <g transform="scale(5.12,5.12)">
          <path d="M9.15625,6.3125l-2.84375,2.84375l15.84375,15.84375l-15.9375,15.96875l2.8125,2.8125l15.96875,-15.9375l15.9375,15.9375l2.84375,-2.84375l-15.9375,-15.9375l15.84375,-15.84375l-2.84375,-2.84375l-15.84375,15.84375z"></path>
        </g>
      </g>
    </svg>
  ),
  copy: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_128_107)">
        <path
          d="M18.3333 5V18.3333H5V5H18.3333ZM20 3.33333H3.33333V20H20V3.33333ZM0 17.5V0H17.5V1.66667H1.66667V17.5H0Z"
          fill="#0D0D0D"
        />
      </g>
      <defs>
        <clipPath id="clip0_128_107">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  sendChat: (props) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00132 15.6979V1.30078M8.00132 1.30078L0.802734 8.49936M8.00132 1.30078L15.1999 8.49936"
        stroke="#F3F3F3"
        stroke-width="1.2766"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  microphone: (props) => (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="#757575"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2290_296)">
        <path
          d="M12.4562 1.3422C13.2544 2.02048 13.7432 2.89442 13.8673 3.93741C13.8783 4.16445 13.8784 4.3911 13.878 4.61836C13.8782 4.68586 13.8784 4.75335 13.8786 4.82085C13.8791 5.00294 13.8792 5.18502 13.8791 5.36711C13.879 5.51978 13.8792 5.67246 13.8794 5.82513C13.8798 6.18575 13.8799 6.54637 13.8796 6.90699C13.8794 7.27741 13.8799 7.64783 13.8807 8.01825C13.8814 8.33767 13.8816 8.65708 13.8815 8.9765C13.8814 9.16666 13.8815 9.35681 13.8821 9.54696C13.8826 9.72604 13.8825 9.9051 13.882 10.0842C13.8819 10.1493 13.882 10.2145 13.8823 10.2797C13.8877 11.4383 13.5538 12.4052 12.7345 13.2343C12.7093 13.2622 12.6842 13.2902 12.6583 13.319C12.07 13.9584 11.1584 14.3242 10.3029 14.372C9.29765 14.4124 8.31151 14.1846 7.54284 13.502C7.44844 13.4147 7.35716 13.3246 7.26572 13.2343C7.2238 13.1966 7.2238 13.1966 7.18104 13.1581C6.51989 12.5498 6.16815 11.6178 6.12539 10.7354C6.12133 10.5593 6.12144 10.3832 6.12156 10.207C6.12133 10.1397 6.12106 10.0724 6.12077 10.0051C6.12008 9.82363 6.11989 9.64219 6.11984 9.46074C6.11979 9.34693 6.11962 9.23313 6.11941 9.11933C6.11869 8.72103 6.11837 8.32274 6.11843 7.92445C6.11848 7.55525 6.11766 7.18606 6.11642 6.81686C6.1154 6.4982 6.11498 6.17954 6.11503 5.86089C6.11505 5.67131 6.11484 5.48175 6.114 5.29218C6.10999 4.31377 6.10715 3.423 6.5626 2.53116C6.58062 2.49566 6.59865 2.46016 6.61722 2.42359C7.09733 1.55912 7.93874 0.918721 8.87034 0.617252C10.1246 0.259147 11.4468 0.533579 12.4562 1.3422Z"
          fill="#757575"
        />
        <path
          d="M4.41371 8.39062C4.59148 8.62043 4.65252 8.81739 4.65362 9.10778C4.6539 9.14879 4.65417 9.18979 4.65446 9.23204C4.65462 9.27619 4.65478 9.32033 4.65495 9.36581C4.65586 9.46095 4.6568 9.55609 4.65777 9.65123C4.65913 9.7999 4.66028 9.94856 4.66081 10.0972C4.66788 11.7515 5.08556 13.1239 6.26429 14.3232C6.89417 14.9415 7.69144 15.4439 8.55433 15.6562C8.59869 15.6675 8.59869 15.6675 8.64394 15.6789C10.0517 16.021 11.5135 15.8153 12.7602 15.0873C13.9227 14.3715 14.8539 13.1947 15.1768 11.8586C15.3197 11.226 15.3344 10.6067 15.3341 9.96045C15.3343 9.8138 15.3346 9.66717 15.3357 9.52052C15.3364 9.43027 15.3365 9.34 15.336 9.24974C15.338 8.94512 15.3692 8.66383 15.5587 8.41504C15.7412 8.23679 15.9176 8.16916 16.1715 8.15625C16.4376 8.17799 16.6206 8.26703 16.7965 8.46875C16.9076 8.65391 16.9574 8.81636 16.9584 9.03077C16.9588 9.0814 16.9588 9.0814 16.9592 9.13305C16.9593 9.18762 16.9593 9.18762 16.9593 9.24329C16.9595 9.2813 16.9597 9.31931 16.9598 9.35847C16.9602 9.48182 16.9602 9.60516 16.9601 9.72852C16.9601 9.77037 16.96 9.81222 16.96 9.85534C16.9583 10.7606 16.9186 11.6141 16.6793 12.4922C16.6721 12.5189 16.665 12.5456 16.6575 12.5731C16.2817 13.9236 15.3591 15.1594 14.2575 16.0078C14.2373 16.0233 14.2172 16.0388 14.1965 16.0548C13.2473 16.7784 11.9959 17.375 10.7809 17.375C10.7809 17.8906 10.7809 18.4062 10.7809 18.9375C11.0113 18.9357 11.2417 18.9339 11.4791 18.932C11.6255 18.9312 11.7718 18.9305 11.9181 18.9299C12.1502 18.9289 12.3822 18.9278 12.6143 18.9257C12.8015 18.924 12.9886 18.9231 13.1758 18.9227C13.2471 18.9224 13.3183 18.9218 13.3896 18.921C13.4897 18.9198 13.5898 18.9197 13.69 18.9198C13.7192 18.9192 13.7484 18.9186 13.7784 18.9181C14.0264 18.92 14.2235 19.0009 14.4146 19.1592C14.5825 19.3625 14.6604 19.5457 14.6456 19.814C14.6128 20.0328 14.5274 20.2162 14.3505 20.3539C14.1475 20.492 13.9974 20.5282 13.7543 20.5248C13.7208 20.5251 13.6872 20.5254 13.6527 20.5257C13.541 20.5265 13.4293 20.5259 13.3177 20.5253C13.2373 20.5255 13.157 20.5259 13.0766 20.5263C12.8588 20.5272 12.6411 20.5269 12.4234 20.5262C12.1953 20.5257 11.9672 20.5262 11.7391 20.5265C11.3561 20.5269 10.9731 20.5264 10.59 20.5255C10.1475 20.5244 9.70498 20.5247 9.26243 20.5258C8.88218 20.5267 8.50194 20.5268 8.12169 20.5263C7.89471 20.526 7.66774 20.526 7.44076 20.5266C7.22734 20.5272 7.01395 20.5268 6.80054 20.5257C6.72231 20.5254 6.64408 20.5255 6.56585 20.5259C6.45887 20.5264 6.35196 20.5258 6.24498 20.5248C6.21419 20.5252 6.18339 20.5257 6.15166 20.5261C5.91971 20.522 5.76773 20.4465 5.58558 20.3047C5.43131 20.1435 5.35829 19.9517 5.34648 19.7302C5.35978 19.4782 5.43255 19.3062 5.61976 19.1353C5.83322 18.9582 6.02331 18.926 6.296 18.9286C6.34348 18.9286 6.34348 18.9286 6.39192 18.9286C6.49612 18.9287 6.60031 18.9293 6.70451 18.9299C6.77692 18.93 6.84933 18.9301 6.92174 18.9302C7.11202 18.9305 7.3023 18.9313 7.49257 18.9321C7.72104 18.9331 7.94951 18.9334 8.17797 18.9339C8.52478 18.9346 8.87158 18.9361 9.21839 18.9375C9.21839 18.4219 9.21839 17.9062 9.21839 17.375C9.05082 17.3621 8.88324 17.3492 8.71058 17.3359C8.57395 17.3107 8.44209 17.284 8.30775 17.2505C8.27264 17.2419 8.23753 17.2332 8.20136 17.2244C6.74555 16.8545 5.39671 15.9581 4.49183 14.7578C4.46081 14.7168 4.4298 14.6757 4.39784 14.6335C4.15095 14.3006 3.94138 13.9531 3.74964 13.5859C3.73711 13.5621 3.72457 13.5383 3.71165 13.5138C3.09948 12.3346 3.04078 11.0389 3.03431 9.73828C3.03394 9.69731 3.03357 9.65634 3.03318 9.61413C3.03225 9.49559 3.03216 9.37709 3.03233 9.25854C3.03197 9.22297 3.03162 9.1874 3.03125 9.15075C3.03364 8.81395 3.11744 8.55408 3.35902 8.3125C3.70912 8.09648 4.09957 8.11933 4.41371 8.39062Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_2290_296">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  chatContinuous: (props) => (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" fill="black" />
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" stroke="#D9D9D9" />
      <rect
        width="15"
        height="15"
        transform="translate(12.5 13)"
        fill="white"
      />
    </svg>
  ),
  smallChatContinuous: (props) => (
    <svg
      width="20"
      height="20.5"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" fill="#757575" />
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" stroke="#D9D9D9" />
      <rect
        width="15"
        height="15"
        transform="translate(12.5 13)"
        fill="white"
      />
    </svg>
  ),

  cogSm: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M6.56484 0L5.62968 2.22569C5.44264 2.2818 5.27431 2.37531 5.10598 2.46883L2.8803 1.53367L1.53367 2.8803L2.46883 5.10598C2.37531 5.29302 2.3005 5.44264 2.22569 5.62968L0 6.56484V8.43516L2.22569 9.37032C2.3005 9.55736 2.37531 9.70698 2.46883 9.89401L1.53367 12.1197L2.8803 13.4663L5.10598 12.5312C5.27431 12.606 5.44264 12.6995 5.62968 12.7743L6.56484 15H8.43516L9.37032 12.7743C9.53865 12.6995 9.72569 12.6247 9.89402 12.5312L12.1197 13.4663L13.4663 12.1197L12.5312 9.89401C12.606 9.72569 12.6995 9.53865 12.7743 9.37032L15 8.43516V6.56484L12.7743 5.62968C12.7182 5.46135 12.6247 5.27431 12.5312 5.10598L13.4663 2.8803L12.1197 1.53367L9.89402 2.46883C9.72569 2.39402 9.53865 2.3005 9.37032 2.22569L8.43516 0L6.56484 0ZM7.5 4.67581C9.05237 4.67581 10.3055 5.92893 10.3055 7.4813C10.3055 9.03367 9.05237 10.2868 7.5 10.2868C5.94763 10.2868 4.69451 9.03367 4.69451 7.4813C4.69451 5.92893 5.94763 4.67581 7.5 4.67581Z"
        fill="#92A5AF"
      />
    </svg>
  ),
  cog: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_55_324)">
        <path
          d="M8.74998 0L7.49998 2.975C7.24998 3.05 7.02498 3.175 6.79998 3.3L3.82498 2.05L2.02498 3.85L3.27498 6.825C3.14998 7.075 3.04998 7.275 2.94998 7.525L-0.0250244 8.775V11.275L2.94998 12.525C3.04998 12.775 3.14998 12.975 3.27498 13.225L2.02498 16.2L3.82498 18L6.79998 16.75C7.02498 16.85 7.24998 16.975 7.49998 17.075L8.74998 20.05H11.25L12.5 17.075C12.725 16.975 12.975 16.875 13.2 16.75L16.175 18L17.975 16.2L16.725 13.225C16.825 13 16.95 12.75 17.05 12.525L20.025 11.275V8.775L17.05 7.525C16.975 7.3 16.85 7.05 16.725 6.825L17.975 3.85L16.175 2.05L13.2 3.3C12.975 3.2 12.725 3.075 12.5 2.975L11.25 0L8.74998 0ZM9.99998 6.25C12.075 6.25 13.75 7.925 13.75 10C13.75 12.075 12.075 13.75 9.99998 13.75C7.92498 13.75 6.24998 12.075 6.24998 10C6.24998 7.925 7.92498 6.25 9.99998 6.25Z"
          fill="#92A5AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_55_324">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  user: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <g clip-path="url(#clip0_99_412)">
        <path
          d="M6.94065 6.032C5.79431 5.76733 4.72731 5.53533 5.24398 4.55933C6.81731 1.58867 5.66098 0 3.99998 0C2.30598 0 1.17865 1.64967 2.75598 4.55933C3.28831 5.541 2.18098 5.773 1.05931 6.032C0.0349789 6.26867 -0.00335443 6.77733 -2.10995e-05 7.66667L0.00131223 8H7.99798L7.99931 7.677C8.00331 6.781 7.96865 6.26967 6.94065 6.032Z"
          fill="#5D737E"
        />
      </g>
      <defs>
        <clipPath id="clip0_99_412">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  exp_dots: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="2.94847" cy="2.94847" r="2.94847" fill="white" />
      <circle cx="2.94847" cy="11.0516" r="2.94847" fill="white" />
      <circle cx="11.0516" cy="2.94847" r="2.94847" fill="white" />
      <circle cx="11.0516" cy="11.0516" r="2.94847" fill="white" />
    </svg>
  ),
  boxes: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
    >
      <rect
        x="2"
        y="2"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="12"
        y="2"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="2"
        y="12"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="12"
        y="12"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  ),
  attachCamera: (props) => (
    <span
      data-testid="attach-camera"
      data-icon="attach-camera"
      className="_1SWzr"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 53 53"
        width="53"
        height="53"
        {...props}
      >
        <defs>
          <circle id="camera-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
        </defs>
        <clipPath id="camera-SVGID_2_">
          <use xlinkHref="#camera-SVGID_1_" overflow="visible"></use>
        </clipPath>
        <g clipPath="url(#camera-SVGID_2_)">
          <path
            fill="#D3396D"
            d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
          ></path>
          <path
            fill="#EC407A"
            d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
          ></path>
          <path fill="#D3396D" d="M17 24.5h15v9H17z"></path>
        </g>
        <g fill="#F5F5F5">
          <path
            id="svg-camera"
            d="M27.795 17a3 3 0 0 1 2.405 1.206l.3.403a3 3 0 0 0 2.405 1.206H34.2a2.8 2.8 0 0 1 2.8 2.8V32a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4v-9.385a2.8 2.8 0 0 1 2.8-2.8h1.295a3 3 0 0 0 2.405-1.206l.3-.403A3 3 0 0 1 25.205 17h2.59zM26.5 22.25a5.25 5.25 0 1 0 .001 10.501A5.25 5.25 0 0 0 26.5 22.25zm0 1.75a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
          ></path>
        </g>
      </svg>
    </span>
  ),
  attachContacts: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="contact-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="contact-SVGID_2_">
        <use xlinkHref="#contact-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#contact-SVGID_2_)">
        <path
          fill="#0795DC"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#0EABF4"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-contact"
          d="M26.5 26.5A4.5 4.5 0 0 0 31 22a4.5 4.5 0 0 0-4.5-4.5A4.5 4.5 0 0 0 22 22a4.5 4.5 0 0 0 4.5 4.5zm0 2.25c-3.004 0-9 1.508-9 4.5v1.125c0 .619.506 1.125 1.125 1.125h15.75c.619 0 1.125-.506 1.125-1.125V33.25c0-2.992-5.996-4.5-9-4.5z"
        ></path>
      </g>
    </svg>
  ),
  attachDocument: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="document-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="document-SVGID_2_">
        <use xlinkHref="#document-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#document-SVGID_2_)">
        <path
          fill="#5157AE"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#5F66CD"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-document"
          d="M29.09 17.09c-.38-.38-.89-.59-1.42-.59H20.5c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H32.5c1.1 0 2-.9 2-2V23.33c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM27.5 22.5V18l5.5 5.5h-4.5c-.55 0-1-.45-1-1z"
        ></path>
      </g>
    </svg>
  ),
  attachImage: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="image-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="image-SVGID_2_">
        <use xlinkHref="#image-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#image-SVGID_2_)">
        <path
          fill="#AC44CF"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#BF59CF"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
        <path fill="#AC44CF" d="M17 24.5h18v9H17z"></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-image"
          d="M18.318 18.25h16.364c.863 0 1.727.827 1.811 1.696l.007.137v12.834c0 .871-.82 1.741-1.682 1.826l-.136.007H18.318a1.83 1.83 0 0 1-1.812-1.684l-.006-.149V20.083c0-.87.82-1.741 1.682-1.826l.136-.007h16.364zm5.081 8.22l-3.781 5.044c-.269.355-.052.736.39.736h12.955c.442-.011.701-.402.421-.758l-2.682-3.449a.54.54 0 0 0-.841-.011l-2.262 2.727-3.339-4.3a.54.54 0 0 0-.861.011zm8.351-5.22a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501z"
        ></path>
      </g>
    </svg>
  ),
  attachRooms: (props) => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="rooms-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="rooms-SVGID_2_">
        <use xlinkHref="#rooms-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#rooms-SVGID_2_)">
        <path
          fill="#396CD3"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#4079EC"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
        <path fill="#396CD3" d="M17 24.5h15v9H17z"></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-rooms"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.5 18a3.5 3.5 0 0 1 3.5 3.5v10a3.5 3.5 0 0 1-3.5 3.5h-10a3.5 3.5 0 0 1-3.5-3.5v-10a3.5 3.5 0 0 1 3.5-3.5h10zm-7.925 6.782a.804.804 0 0 0-1.045-.073l-.708.698-.297.33-.134.177a4.075 4.075 0 0 0 .433 5.265 4.07 4.07 0 0 0 2.886 1.198c.976 0 1.952-.349 2.73-1.05l.784-.777.077-.091.063-.102.045-.105a.797.797 0 0 0-.189-.824.806.806 0 0 0-1.045-.073l-.704.694-.123.116-.147.119-.15.105a2.5 2.5 0 0 1-3.099-.337 2.492 2.492 0 0 1-.12-3.392l.748-.756.076-.091.063-.102.046-.105a.794.794 0 0 0-.19-.824zm5.281-.637a.803.803 0 0 0-1.044-.073l-3.67 3.662-.078.091-.063.102-.045.105a.793.793 0 0 0 .754 1.056.805.805 0 0 0 .481-.16l3.671-3.662.076-.09.064-.102.045-.105a.795.795 0 0 0-.191-.824zm2.323-2.323a4.078 4.078 0 0 0-5.615-.149l-.785.777-.073.084-.062.098a.806.806 0 0 0 .14.941.803.803 0 0 0 1.043.072l.705-.693.127-.119.137-.111a2.494 2.494 0 0 1 3.257.227c.921.923.972 2.413.117 3.392l-.746.755-.072.084-.062.098a.8.8 0 0 0 .139.941.8.8 0 0 0 1.043.072l.709-.697.148-.156.145-.17a4.084 4.084 0 0 0-.295-5.446zm9.815-.188l.006.129v9.474c0 1.31-1.714 1.998-2.744 1.12l-.878-.847a2.828 2.828 0 0 1-.871-1.849l-.007-.19v-5.943c0-.765.316-1.498.879-2.039l.877-.846c.996-.848 2.631-.234 2.738.991z"
        ></path>
      </g>
    </svg>
  ),
  back: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"
      ></path>
    </svg>
  ),
  block: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2.8c-5.3 0-9.7 4.3-9.7 9.7s4.3 9.7 9.7 9.7 9.7-4.3 9.7-9.7-4.4-9.7-9.7-9.7zm-7.3 9.7c0-4 3.3-7.3 7.3-7.3 1.6 0 3.1.5 4.3 1.4L6.1 16.8c-.9-1.2-1.4-2.7-1.4-4.3zm7.3 7.3c-1.6 0-3-.5-4.2-1.4L17.9 8.3c.9 1.2 1.4 2.6 1.4 4.2 0 4-3.3 7.3-7.3 7.3z"
      ></path>
    </svg>
  ),
  cancel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.1 17.2l-5.3-5.3 5.3-5.3-1.8-1.8-5.3 5.4-5.3-5.3-1.8 1.7 5.3 5.3-5.3 5.3L6.7 19l5.3-5.3 5.3 5.3 1.8-1.8z"
      ></path>
    </svg>
  ),
  chat: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.005 3.175H4.674C3.642 3.175 3 3.789 3 4.821V21.02l3.544-3.514h12.461c1.033 0 2.064-1.06 2.064-2.093V4.821c-.001-1.032-1.032-1.646-2.064-1.646zm-4.989 9.869H7.041V11.1h6.975v1.944zm3-4H7.041V7.1h9.975v1.944z"
      ></path>
    </svg>
  ),
  check: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="check"
      viewBox="0 0 18 13"
      fill="none"
      {...props}
    >
      <path
        d="M6.99974 10.172L16.1917 0.979004L17.6067 2.393L6.99974 13L0.635742 6.636L2.04974 5.222L6.99974 10.172Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  delete: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
    >
      <g clip-path="url(#clip0_99_400)">
        <path
          d="M3.25929 0.414609C3.38946 0.1605 3.65705 0 3.94875 0H6.85125C7.14295 0 7.41054 0.1605 7.54071 0.414609L7.71429 0.75H10.0286C10.4553 0.75 10.8 1.08586 10.8 1.5C10.8 1.91414 10.4553 2.25 10.0286 2.25H0.771429C0.345455 2.25 0 1.91414 0 1.5C0 1.08586 0.345455 0.75 0.771429 0.75H3.08571L3.25929 0.414609ZM0.749732 3H10.0286V10.5C10.0286 11.3273 9.3367 12 8.48571 12H2.29259C1.4621 12 0.749732 11.3273 0.749732 10.5V3ZM2.6783 4.875V10.125C2.6783 10.3313 2.87357 10.5 3.06402 10.5C3.29786 10.5 3.44973 10.3313 3.44973 10.125V4.875C3.44973 4.66875 3.29786 4.5 3.06402 4.5C2.87357 4.5 2.6783 4.66875 2.6783 4.875ZM4.99259 4.875V10.125C4.99259 10.3313 5.18786 10.5 5.3783 10.5C5.61214 10.5 5.78571 10.3313 5.78571 10.125V4.875C5.78571 4.66875 5.61214 4.5 5.3783 4.5C5.18786 4.5 4.99259 4.66875 4.99259 4.875ZM7.32857 4.875V10.125C7.32857 10.3313 7.50214 10.5 7.71429 10.5C7.92643 10.5 8.1 10.3313 8.1 10.125V4.875C8.1 4.66875 7.92643 4.5 7.71429 4.5C7.50214 4.5 7.32857 4.66875 7.32857 4.875Z"
          fill="#5D737E"
        />
      </g>
      <defs>
        <clipPath id="clip0_99_400">
          <rect width="10.8" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  doubleTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15"
      width="16"
      height="15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      ></path>
    </svg>
  ),
  downArrow: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 6.7l5.7 5.7 5.7-5.7 1.6 1.6-7.3 7.2-7.3-7.2 1.6-1.6z"
      ></path>
    </svg>
  ),
  upArrow: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 13.3l5.7-5.7 5.7 5.7 1.6-1.6-7.3-7.2-7.3 7.2 1.6 1.6z"
      ></path>
    </svg>
  ),

  upArrow12: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="11"
      height="12"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 13.3l5.7-5.7 5.7 5.7 1.6-1.6-7.3-7.2-7.3 7.2 1.6 1.6z"
      ></path>
    </svg>
  ),
  emojiActivity: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.8 15.3l1.3-3.8c.1-.2 0-.5-.2-.6l-3.3-2.4c-.2-.1-.5-.1-.6 0l-3.3 2.4c-.2.1-.3.4-.2.6l1.3 3.8c.1.2.3.4.5.4h4c.2 0 .4-.2.5-.4z"
      ></path>
      <path
        fill="currentColor"
        d="M12 1.9C6.4 1.9 1.9 6.4 1.9 12S6.4 22.1 12 22.1 22.1 17.6 22.1 12 17.6 1.9 12 1.9zM9.8 20.3c.1-.2.1-.4 0-.6l-1.4-2.3c-.1-.1-.2-.2-.4-.3l-2.5-.6c-.2-.1-.5.1-.6.2-.9-1.3-1.4-2.9-1.5-4.5.2 0 .4 0 .5-.2l1.7-2c.1 0 .2-.2.2-.3l-.3-2.6c0-.2-.1-.3-.3-.4C6.2 5.4 7.5 4.5 9 4c0 .1.2.3.3.3l2.5 1.1c.1.1.3.1.4 0l2.5-1.1.3-.3c1.5.6 2.7 1.5 3.7 2.7-.1.1-.2.2-.2.4l-.2 2.6c0 .2 0 .3.1.4l1.7 2c.1.1.3.2.4.2 0 1.6-.5 3.1-1.3 4.4-.1-.1-.2-.1-.4-.1l-2.5.6c-.1 0-.3.1-.4.3l-1.4 2.3c-.1.2-.1.3 0 .5-.8.2-1.6.4-2.5.4-.7-.1-1.5-.2-2.2-.4z"
      ></path>
    </svg>
  ),
  emojiFlags: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.5 3.8v-.2c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5V21c0 .3.2.5.5.5H5c.3 0 .5-.2.5-.5v-6.2c5 1.8 9.3-2.7 14.5.6V4.1C14.9 1 10.3 5.6 5.5 3.8zm10.3 8.8c-1.4 0-2.8.3-4.1.6-1.2.3-2.4.5-3.5.5-.9 0-1.8-.2-2.6-.5V5.4c.8.2 1.5.3 2.3.3 1.5 0 2.9-.4 4.3-.7 1.3-.3 2.5-.6 3.8-.6.9 0 1.7.2 2.5.5V13c-.9-.2-1.8-.4-2.7-.4z"
      ></path>
    </svg>
  ),
  emojiFood: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.4 11.4c-.4 0-.8.4-.8.8V14c0 .4.4.8.8.8s.8-.4.6-.8v-1.8c0-.6-.2-.8-.6-.8zM4.6 10.4c-.4 0-.8.4-.8.8V15c0 .4.4.8.8.8s.8-.4.8-.8v-3.8c0-.6-.4-.8-.8-.8z"
      ></path>
      <path
        fill="currentColor"
        d="M23 7.2c-.6-.6-1.6-.8-2.8-.6-.2 0-.4.2-.6.2V4.2c0-.6-.6-1.2-1.2-1.2h-17C.8 3 .2 3.6.2 4.2v7.4c0 5.4 3.2 9.6 8.4 9.6h2.2c4.2 0 7-2.6 8-6h.4c2.2-.4 4-2.6 4.4-4.8.4-1.4.2-2.4-.6-3.2zm-4.8-2.8v3H1.6v-3h16.6zM11 19.8H8.8c-5.2 0-7-4.4-7-8.2V8.8h16.6v2.8c-.2 4-2.4 8.2-7.4 8.2zm8.4-6.2c.2-.6.2-1.4.2-2V8.4c.4-.2.6-.4 1-.4.6-.2 1.2 0 1.4.4.4.4.6 1 .4 1.8-.2 1.4-1.6 3-3 3.4z"
      ></path>
    </svg>
  ),
  emojiNature: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.2 12.2c.608 0 1.1.627 1.1 1.4S7.808 15 7.2 15s-1.1-.627-1.1-1.4.492-1.4 1.1-1.4zm9.7 0c.608 0 1.1.627 1.1 1.4s-.492 1.4-1.1 1.4-1.1-.627-1.1-1.4.492-1.4 1.1-1.4zm4.6-1.1l-1.2-2.4c.9-.4 1.7-1.3 2-2.2.3-.7.4-2.1-1-3.5-1-.9-2-1.2-2.9-1-1.1.3-1.9 1.2-2.3 1.9-1.4-.7-2.9-.8-4.1-.8-1.5 0-2.8.3-4 .9-.5-.9-1.2-1.8-2.3-2.1-1-.2-2 .1-2.9 1-1 1-1.4 2.2-1 3.4.4 1.1 1.2 1.9 2 2.3-.2.5-.4 1-.6 1.6l-.2.2c-.3.7-.5 1.3-.8 1.9-.4 1-.9 1.9-.9 3.1 0 1.6.8 6.7 10.5 6.7 3.8 0 6.6-.7 8.5-2.2s2.2-3.4 2.2-4.3c.2-2.1-.2-2.9-1-4.5zm-2.7-7.6c.4-.1.9.1 1.5.6.6.6.8 1.2.6 1.8-.2.6-.7 1.1-1.2 1.3-.6-1.2-1.3-2-2.1-2.6.2-.4.6-1 1.2-1.1zM3.3 5.9c-.2-.6 0-1.2.6-1.8.5-.5 1.1-.7 1.5-.6.5.1 1.1.7 1.3 1.2-.9.7-1.6 1.5-2.2 2.6C4 7 3.4 6.5 3.3 5.9zm17.8 9.7c0 .7-.2 2-1.6 3.1-1.5 1.2-4.1 1.8-7.5 1.8-8.3 0-8.9-3.9-8.9-5.1 0-.8.3-1.5.7-2.4.3-.6.6-1.2.8-2.1l.1-.2c.5-1.5 2-6.2 7.3-6.2 1.2 0 2.5.2 3.7.9.1.1.5.3.5.3.9.7 1.7 1.7 2.4 3.2.6 1.3 1 2.2 1.4 2.9.8 1.6 1.1 2.1 1.1 3.8zM14.6 17c-.1.1-.6.4-1.2.3-.4-.1-.7-.3-.9-.8 0-.1-.1-.1-.1-.2.8-.1 1.3-.6 1.3-1.3s-.7 0-1.7 0c-.9 0-1.7-.7-1.7 0 0 .6.6 1.2 1.4 1.3l-.1.1c-.3.4-.5.7-.9.8-.5.1-1.1-.1-1.3-.3-.2-.2-.5-.1-.7.1s-.1.5.1.7c.1.1.8.5 1.6.5.2 0 .4 0 .5-.1.4-.1.8-.3 1.1-.7.4.4.9.6 1.2.7.8.2 1.7-.2 2-.5.2-.2.2-.5 0-.7-.1 0-.4-.1-.6.1z"
      ></path>
    </svg>
  ),
  emojiObjects: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.8 6.7c-.9-2.6-3.2-4.6-6-4.9h-1.6c-2.8.3-5.1 2.2-6 4.9-1 3 .1 6.2 2.7 8H8c.2.1.3.4.3.6v2c0 .8.6 1.4 1.4 1.4h4.6c.8 0 1.4-.6 1.4-1.4v-2c0-.2.1-.5.3-.6l.1-.1c2.5-1.8 3.6-5 2.7-7.9zm-3.5 6.9l-.1.1c-.5.4-.9 1-.9 1.7v2s0 .1-.1.1H9.8s-.1 0-.1-.1v-2c0-.7-.3-1.3-.9-1.7l-.1-.1c-2-1.4-3-4-2.2-6.5.7-2.1 2.6-3.7 4.9-3.9H12.7c2.2.2 4.2 1.8 4.9 3.9.7 2.4-.2 5-2.3 6.5zM9.2 21.2c0 .6.5 1 1 1h3.7c.6 0 1-.5 1-1v-1H9.2v1z"
      ></path>
      <path
        fill="currentColor"
        d="M13.6 10.5c-.4 0-.8.3-.8.8 0 .1 0 .2.1.3-.2.3-.5.5-.8.5s-.6-.2-.8-.5c0-.1.1-.2.1-.3 0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8 0 .4.3.7.7.8.3.4.7.7 1.1.8V15c0 .2.2.4.4.4s.4-.2.4-.4v-2.1c.4-.1.8-.4 1.1-.8.4 0 .8-.3.8-.8s-.3-.8-.7-.8z"
      ></path>
    </svg>
  ),
  emojiPeople: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 22.1C6.4 22.1 1.9 17.6 1.9 12S6.4 1.9 12 1.9 22.1 6.4 22.1 12 17.6 22.1 12 22.1zm0-18.6c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5z"
      ></path>
      <path
        fill="currentColor"
        d="M8.9 11.6c.7 0 1.3-.7 1.3-1.5s-.6-1.5-1.3-1.5-1.3.7-1.3 1.5.6 1.5 1.3 1.5zM17.1 13.6c-1.1.1-3 .4-5 .4s-4-.3-5-.4c-.4 0-.6.3-.4.7 1.1 2 3.1 3.5 5.5 3.5 2.3 0 4.4-1.5 5.5-3.5.1-.3-.2-.7-.6-.7zM12.3 16c-2.6 0-4.1-1-4.2-1.6 0 0 4.4.9 8 0 0 0-.5 1.6-3.8 1.6zM15.1 11.6c.7 0 1.3-.7 1.3-1.5s-.6-1.5-1.3-1.5-1.3.7-1.3 1.5.6 1.5 1.3 1.5z"
      ></path>
    </svg>
  ),
  emojiSymbols: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.5 12.9V11h2.2l-.2-1.3h-2V7.3H13v2.5h-2V7.4H9.5v2.4H7.2l.2 1.2h2.1v1.9H7.3l.2 1.3h2v2.4H11v-2.4h2v2.4h1.5v-2.4h2.3l-.2-1.3h-2.1zM11 11h2v1.9h-2V11z"
      ></path>
      <path
        fill="currentColor"
        d="M16.1 2.6H7.9C5 2.6 2.6 5 2.6 7.9V16c0 3 2.4 5.3 5.3 5.3H16c3 0 5.3-2.4 5.3-5.3V7.9c.1-2.9-2.3-5.3-5.2-5.3zm3.7 13.5c0 2.1-1.6 3.8-3.7 3.8H7.9c-2.1 0-3.8-1.7-3.8-3.8V7.9c0-2.1 1.7-3.8 3.8-3.8H16c2.1 0 3.8 1.7 3.8 3.8v8.2z"
      ></path>
    </svg>
  ),
  emojiTravel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.5 11.5c0-.7-.1-1.4-.3-2l-1.5-4.3C19.2 3.9 18 3 16.6 3H7.3c-1.4 0-2.6.9-3.1 2.2L2.6 9.9c-.1.4-.2.7-.2 1.1v8.6c0 .6.5 1.1 1.1 1.1h1.1c.6 0 1.1-.5 1.1-1.1v-1.1h12.7v1.1c0 .6.5 1.1 1.1 1.1h1.1c.6 0 1.1-.5 1.1-1.1v-7.4l-.2-.7zM4.1 10.4l1.6-4.7c.2-.7.9-1.2 1.7-1.2h9.2c.7 0 1.4.5 1.6 1.2l1.5 4.3c.1.3.2.6.2.8H4c-.1-.1 0-.3.1-.4zm1.4 5.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c-.1.8-.7 1.5-1.5 1.5zm9.4-.6H9.3c-.5 0-1-.4-1-1 0-.5.4-1 1-1h5.6c.5 0 1 .4 1 1-.1.6-.5 1-1 1zm3.7.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
      ></path>
    </svg>
  ),
  gif: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.177 12.013l-.001-.125v-.541-.512c0-.464 0-.827-.002-1.178a.723.723 0 0 0-.557-.7.715.715 0 0 0-.826.4c-.05.115-.072.253-.073.403-.003 1.065-.003 1.917-.002 3.834v.653c0 .074.003.136.009.195a.72.72 0 0 0 .57.619c.477.091.878-.242.881-.734.002-.454.003-.817.002-1.633l-.001-.681zm-3.21-.536a35.751 35.751 0 0 0-1.651-.003c-.263.005-.498.215-.565.48a.622.622 0 0 0 .276.7.833.833 0 0 0 .372.104c.179.007.32.008.649.005l.137-.001v.102c-.001.28-.001.396.003.546.001.044-.006.055-.047.081-.242.15-.518.235-.857.275-.767.091-1.466-.311-1.745-1.006a2.083 2.083 0 0 1-.117-1.08 1.64 1.64 0 0 1 1.847-1.41c.319.044.616.169.917.376.196.135.401.184.615.131a.692.692 0 0 0 .541-.562c.063-.315-.057-.579-.331-.766-.789-.542-1.701-.694-2.684-.482-2.009.433-2.978 2.537-2.173 4.378.483 1.105 1.389 1.685 2.658 1.771.803.054 1.561-.143 2.279-.579.318-.193.498-.461.508-.803.014-.52.015-1.046.001-1.578-.009-.362-.29-.669-.633-.679zM18 4.25H6A4.75 4.75 0 0 0 1.25 9v6A4.75 4.75 0 0 0 6 19.75h12A4.75 4.75 0 0 0 22.75 15V9A4.75 4.75 0 0 0 18 4.25zM21.25 15A3.25 3.25 0 0 1 18 18.25H6A3.25 3.25 0 0 1 2.75 15V9A3.25 3.25 0 0 1 6 5.75h12A3.25 3.25 0 0 1 21.25 9v6zm-2.869-6.018H15.3c-.544 0-.837.294-.837.839V14.309c0 .293.124.525.368.669.496.292 1.076-.059 1.086-.651.005-.285.006-.532.004-1.013v-.045l-.001-.46v-.052h1.096l1.053-.001a.667.667 0 0 0 .655-.478c.09-.298-.012-.607-.271-.757a.985.985 0 0 0-.468-.122 82.064 82.064 0 0 0-1.436-.006h-.05l-.523.001h-.047v-1.051h1.267l1.22-.001c.458-.001.768-.353.702-.799-.053-.338-.35-.56-.737-.561z"
      ></path>
    </svg>
  ),
  laptop: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 18"
      width="21"
      height="18"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.426 14.235a.767.767 0 0 1-.765-.765c0-.421.344-.765.765-.765s.765.344.765.765-.344.765-.765.765zM4.309 3.529h12.235v8.412H4.309V3.529zm12.235 9.942c.841 0 1.522-.688 1.522-1.529l.008-8.412c0-.842-.689-1.53-1.53-1.53H4.309c-.841 0-1.53.688-1.53 1.529v8.412c0 .841.688 1.529 1.529 1.529H1.25c0 .842.688 1.53 1.529 1.53h15.294c.841 0 1.529-.688 1.529-1.529h-3.058z"
      ></path>
    </svg>
  ),
  lock: (props) => (
    <svg
      width="10px"
      height="12px"
      viewBox="0 0 10 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.00847986,1.6 C6.38255462,1.6 7.50937014,2.67435859 7.5940156,4.02703389 L7.59911976,4.1906399 L7.599,5.462 L7.75719976,5.46214385 C8.34167974,5.46214385 8.81591972,5.94158383 8.81591972,6.53126381 L8.81591972,9.8834238 C8.81591972,10.4731038 8.34167974,10.9525438 7.75719976,10.9525438 L2.25767996,10.9525438 C1.67527998,10.9525438 1.2,10.4731038 1.2,9.8834238 L1.2,6.53126381 C1.2,5.94158383 1.67423998,5.46214385 2.25767996,5.46214385 L2.416,5.462 L2.41679995,4.1906399 C2.41679995,2.81636129 3.49135449,1.68973395 4.84478101,1.60510326 L5.00847986,1.6 Z M5.00847986,2.84799995 C4.31163824,2.84799995 3.73624912,3.38200845 3.6709675,4.06160439 L3.6647999,4.1906399 L3.663,5.462 L6.35,5.462 L6.35111981,4.1906399 C6.35111981,3.53817142 5.88169076,2.99180999 5.26310845,2.87228506 L5.13749818,2.85416626 L5.00847986,2.84799995 Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  menu: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7zm0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 9zm0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 15z"
      ></path>
    </svg>
  ),
  microphone: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"
      ></path>
    </svg>
  ),
  notification: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.154 2C11.919 2 2 11.924 2 24.165S11.919 46.33 24.154 46.33s22.154-9.924 22.154-22.165S36.389 2 24.154 2zm-.744 15.428v-.618c0-.706.618-1.324 1.324-1.324s1.323.618 1.323 1.324v.618c2.559.618 4.412 2.823 4.412 5.559v3.176l-8.294-8.294a5.056 5.056 0 0 1 1.235-.441zm1.323 15.706a1.77 1.77 0 0 1-1.765-1.765h3.529a1.768 1.768 0 0 1-1.764 1.765zm7.236-.883l-1.765-1.765H17.233v-.882l1.765-1.765v-4.853a5.56 5.56 0 0 1 .794-2.912l-2.559-2.559 1.147-1.147 14.735 14.736-1.146 1.147z"
      ></path>
    </svg>
  ),
  noWifi: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.154 2C11.919 2 2 11.924 2 24.165S11.919 46.33 24.154 46.33s22.154-9.924 22.154-22.165S36.389 2 24.154 2zm-.169 32.138L12.976 19.459c3.028-2.294 6.881-3.67 11.009-3.67 4.129 0 7.982 1.376 11.009 3.67L23.985 34.138zm-.945-5.65h1.981v-1.981H23.04v1.981zm0-3.962h1.981v-5.017H23.04v5.017z"
      ></path>
    </svg>
  ),
  pinned: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 19"
      width="19"
      height="19"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.5 18.419C4.574 18.419.581 14.426.581 9.5S4.574.581 9.5.581s8.919 3.993 8.919 8.919-3.993 8.919-8.919 8.919zm2.121-5.708l-.082-2.99 1.647-1.963a1.583 1.583 0 0 0-.188-2.232l-.32-.269a1.58 1.58 0 0 0-2.231.203L8.803 7.42l-2.964.439a.282.282 0 0 0-.14.496l5.458 4.58c.186.157.47.019.464-.224zM5.62 13.994a.504.504 0 0 0 .688-.038l2.204-2.307-1.085-.91-1.889 2.571a.504.504 0 0 0 .082.684z"
      ></path>
    </svg>
  ),
  recent: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.538 11.975a8.563 8.563 0 1 0-17.126 0 8.563 8.563 0 0 0 17.126 0zm1.412 0c0 5.509-4.466 9.975-9.975 9.975C6.465 21.95 2 17.484 2 11.975 2 6.465 6.466 2 11.975 2c5.509 0 9.975 4.466 9.975 9.975zm-9.832-5.27v5.692l4.386 2.627a.706.706 0 1 1-.725 1.212l-5.073-3.04v-6.49a.706.706 0 1 1 1.412 0z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  rightArrow: (props) => (
    <span
      data-testid="chevron-right-alt"
      data-icon="chevron-right-alt"
      className="pQbiR"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 21"
        width="10"
        height="21"
      >
        <path
          fill="currentColor"
          d="M1 15.75l5.2-5.2L1 5.35l1.5-1.5 6.5 6.7-6.6 6.6-1.4-1.4z"
        ></path>
      </svg>
    </span>
  ),
  search: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z"
      ></path>
    </svg>
  ),
  send: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"
      ></path>
    </svg>
  ),
  singleTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15"
      width="16"
      height="15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.91 3.316l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      ></path>
    </svg>
  ),
  smiley: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"
      ></path>
    </svg>
  ),
  status: (props) => (
    <svg
      id="df9d3429-f0ef-48b5-b5eb-f9d27b2deba6"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.072 1.761a10.05 10.05 0 0 0-9.303 5.65.977.977 0 0 0 1.756.855 8.098 8.098 0 0 1 7.496-4.553.977.977 0 1 0 .051-1.952zM1.926 13.64a10.052 10.052 0 0 0 7.461 7.925.977.977 0 0 0 .471-1.895 8.097 8.097 0 0 1-6.012-6.386.977.977 0 0 0-1.92.356zm13.729 7.454a10.053 10.053 0 0 0 6.201-8.946.976.976 0 1 0-1.951-.081v.014a8.097 8.097 0 0 1-4.997 7.209.977.977 0 0 0 .727 1.813l.02-.009z"
      ></path>
      <path fill="#009588" d="M19 1.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"></path>
    </svg>
  ),
  sticker: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.799 10.183c-.002-.184-.003-.373-.008-.548-.02-.768-.065-1.348-.173-1.939a6.6 6.6 0 0 0-.624-1.87 6.24 6.24 0 0 0-1.171-1.594 6.301 6.301 0 0 0-1.614-1.159 6.722 6.722 0 0 0-1.887-.615c-.59-.106-1.174-.15-1.961-.171-.318-.008-3.607-.012-4.631 0-.798.02-1.383.064-1.975.17a6.783 6.783 0 0 0-1.888.616 6.326 6.326 0 0 0-2.785 2.753 6.658 6.658 0 0 0-.623 1.868c-.107.591-.152 1.186-.173 1.941-.008.277-.016 2.882-.016 2.882 0 .52.008 1.647.016 1.925.02.755.066 1.349.172 1.938.126.687.33 1.3.624 1.871.303.59.698 1.126 1.173 1.595a6.318 6.318 0 0 0 1.614 1.159 6.786 6.786 0 0 0 2.146.656c.479.068.833.087 1.633.108.035.001 2.118-.024 2.578-.035a6.873 6.873 0 0 0 4.487-1.811 210.877 210.877 0 0 0 2.928-2.737 6.857 6.857 0 0 0 2.097-4.528l.066-1.052.001-.668c.001-.023-.005-.738-.006-.755zm-3.195 5.92c-.79.757-1.784 1.684-2.906 2.716a5.356 5.356 0 0 1-2.044 1.154c.051-.143.116-.276.145-.433.042-.234.06-.461.067-.74.003-.105.009-.789.009-.789.013-.483.042-.865.107-1.22.069-.379.179-.709.336-1.016.16-.311.369-.595.621-.844.254-.252.542-.458.859-.617.314-.158.65-.268 1.037-.337a8.127 8.127 0 0 1 1.253-.106s.383.001.701-.003a4.91 4.91 0 0 0 .755-.066c.186-.034.348-.105.515-.169a5.35 5.35 0 0 1-1.455 2.47zm1.663-4.757a1.128 1.128 0 0 1-.615.859 1.304 1.304 0 0 1-.371.119 3.502 3.502 0 0 1-.52.043c-.309.004-.687.004-.687.004-.613.016-1.053.049-1.502.129a5.21 5.21 0 0 0-1.447.473 4.86 4.86 0 0 0-2.141 2.115 5.088 5.088 0 0 0-.479 1.434 9.376 9.376 0 0 0-.131 1.461s-.006.684-.008.777c-.006.208-.018.37-.043.511a1.154 1.154 0 0 1-.626.86c-.072.036-.168.063-.37.098-.027.005-.25.027-.448.031-.021 0-1.157.01-1.192.009-.742-.019-1.263-.046-1.668-.126a5.27 5.27 0 0 1-1.477-.479 4.823 4.823 0 0 1-2.127-2.1 5.141 5.141 0 0 1-.482-1.453c-.09-.495-.13-1.025-.149-1.71a36.545 36.545 0 0 1-.012-.847c-.003-.292.005-3.614.012-3.879.02-.685.061-1.214.151-1.712a5.12 5.12 0 0 1 .481-1.45c.231-.449.53-.856.892-1.213.363-.36.777-.657 1.233-.886a5.26 5.26 0 0 1 1.477-.479c.503-.09 1.022-.129 1.74-.149a342.03 342.03 0 0 1 4.561 0c.717.019 1.236.058 1.737.148a5.263 5.263 0 0 1 1.476.478 4.835 4.835 0 0 1 2.126 2.098c.228.441.385.913.482 1.453.091.499.131 1.013.15 1.712.008.271.014 1.098.014 1.235a2.935 2.935 0 0 1-.037.436z"
      ></path>
    </svg>
  ),
  thumbsDown: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.091 4.2H6.318c-.691 0-1.295.432-1.555 1.036l-2.591 6.132c-.086.173-.172.346-.172.605V13.7c0 .95.777 1.727 1.727 1.727h5.441L8.305 19.4v.259c0 .345.173.691.345.95l.95.864 5.7-5.7c.345-.345.518-.777.518-1.209V5.927c0-.95-.777-1.727-1.727-1.727zm3.454 0v10.364H21V4.2h-3.455z"
        id="thumb-down"
      ></path>
    </svg>
  ),
  whatsapp: (props) => (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="48px"
      height="48px"
      {...props}
    >
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z" />
    </svg>
  ),
  ellipsis: (props) => (
    <svg
      width="5"
      height="18"
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 4.5C1.008 4.5 0 3.492 0 2.25C0 1.008 1.008 0 2.25 0C3.492 0 4.5 1.008 4.5 2.25C4.5 3.492 3.492 4.5 2.25 4.5ZM2.25 11.25C1.008 11.25 0 10.242 0 9C0 7.758 1.008 6.75 2.25 6.75C3.492 6.75 4.5 7.758 4.5 9C4.5 10.242 3.492 11.25 2.25 11.25ZM2.25 18C1.008 18 0 16.992 0 15.75C0 14.508 1.008 13.5 2.25 13.5C3.492 13.5 4.5 14.508 4.5 15.75C4.5 16.992 3.492 18 2.25 18Z"
        fill="#757575"
      />
    </svg>
  ),
  brainai: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_160_200)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3299 19.9992H2.8257C2.8257 19.9992 3.43736 16.7233 3.3532 15.2608C3.31903 14.6575 3.21903 14.0325 2.9032 13.5075C2.3657 12.6742 0.706529 10.4075 0.840696 7.31583C1.02736 2.975 4.75153 0 9.27903 0C13.5274 0 16.3682 2.50083 17.494 6.23583C17.7674 7.135 17.7532 7.52 17.3682 8.40833L17.3632 8.41917L18.8224 10.2042C19.039 10.5217 19.1665 10.8633 19.1665 11.2367C19.1665 11.6925 18.9724 12.1075 18.6582 12.4025C18.3515 12.69 18.019 12.7792 17.6182 12.9375C17.6182 12.9375 17.1382 15.0975 16.8907 15.68C16.3074 17.0492 15.249 17.0625 14.4157 17.2208C14.0874 17.29 14.0074 17.3317 13.8482 17.7883C13.6749 18.2808 13.5457 18.9842 13.3299 19.9992ZM9.29486 1.66583C5.72403 1.70583 2.84486 3.78917 2.52736 7.0725C2.36736 8.73167 2.9132 10.3942 3.7907 11.8267C4.29986 12.66 4.8782 13.1533 5.0107 15.0558C5.08653 16.15 4.96903 17.2525 4.80986 18.3325H11.9799C12.0974 17.795 12.2715 17.095 12.5524 16.6183C12.9265 15.98 13.4665 15.7025 14.1574 15.5733C14.8557 15.45 15.189 15.5242 15.3982 14.9192C15.5749 14.4367 15.9082 13.0683 16.0907 11.6675C17.0932 11.3883 16.6007 11.5333 17.4832 11.2017C17.3115 11.0067 15.8849 9.27333 15.779 9.035C15.499 8.4025 15.7407 8.04333 15.9665 7.44083C16.0382 7.23167 16.0165 7.14333 15.959 6.93C15.0849 3.63917 12.7165 1.66583 9.29486 1.66583ZM9.7282 4.16583C9.92986 4.73583 9.9882 5.10083 10.429 5.28333C10.8707 5.4675 11.174 5.24667 11.7157 4.98917L12.5099 5.7825C12.2499 6.32833 12.0324 6.62917 12.2149 7.06917C12.3974 7.50917 12.759 7.5675 13.3332 7.77083V8.89333C12.7657 9.09583 12.3974 9.15417 12.2149 9.59583C12.0315 10.0367 12.2507 10.3383 12.5099 10.8825L11.7157 11.6758C11.1682 11.415 10.8707 11.1975 10.4315 11.38C9.98903 11.565 9.92986 11.9308 9.7282 12.4992H8.60486C8.4032 11.9292 8.34486 11.5642 7.90403 11.3825L7.9032 11.3817C7.46236 11.1975 7.15986 11.4175 6.61653 11.6758L5.8232 10.8825C6.07736 10.3467 6.30153 10.04 6.11736 9.595C5.93403 9.15417 5.56653 9.09583 4.99986 8.89333V7.77083C5.56736 7.56917 5.93403 7.51083 6.11736 7.07C6.3007 6.6275 6.08236 6.3275 5.8232 5.7825L6.61653 4.98917C7.16403 5.24917 7.46236 5.46667 7.9032 5.28333C8.34403 5.10083 8.4032 4.7325 8.60486 4.16583H9.7282ZM9.16653 9.72167C8.39986 9.72167 7.77736 9.1 7.77736 8.3325C7.77736 7.565 8.39986 6.94333 9.16653 6.94333C9.9332 6.94333 10.5549 7.565 10.5549 8.3325C10.5549 9.1 9.9332 9.72167 9.16653 9.72167Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_160_200">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  vectorfile: (props) => (
    <svg
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V17C12 19.757 9.757 22 7 22C4.243 22 2 19.757 2 17V5C2 3.346 3.346 2 5 2C6.654 2 8 3.346 8 5V14C8 14.551 7.551 15 7 15C6.449 15 6 14.551 6 14V6H4V14C4 15.657 5.343 17 7 17C8.657 17 10 15.657 10 14V5C10 2.239 7.761 0 5 0C2.239 0 0 2.239 0 5V17C0 20.866 3.134 24 7 24C10.866 24 14 20.866 14 17V5H12Z"
        fill="black"
      />
    </svg>
  ),
  threeDots: (props) => (
    <svg
      width="5"
      height="18"
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.25 4.5C1.008 4.5 0 3.492 0 2.25C0 1.008 1.008 0 2.25 0C3.492 0 4.5 1.008 4.5 2.25C4.5 3.492 3.492 4.5 2.25 4.5ZM2.25 11.25C1.008 11.25 0 10.242 0 9C0 7.758 1.008 6.75 2.25 6.75C3.492 6.75 4.5 7.758 4.5 9C4.5 10.242 3.492 11.25 2.25 11.25ZM2.25 18C1.008 18 0 16.992 0 15.75C0 14.508 1.008 13.5 2.25 13.5C3.492 13.5 4.5 14.508 4.5 15.75C4.5 16.992 3.492 18 2.25 18Z"
        fill="#757575"
      />
    </svg>
  ),
  share: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7568 6.62666L9.60059 11.0534C9.15 11.4431 8.43779 11.128 8.43779 10.5214V7.97139C3.89355 8.03584 1.93535 9.16377 3.26367 13.4118C3.41106 13.8832 2.8415 14.2485 2.4416 13.9573C1.15986 13.0251 0 11.2438 0 9.44209C0 4.9831 3.73242 4.03974 8.4375 3.98408V1.64092C8.4375 1.03535 9.14883 0.719237 9.60029 1.10889L14.7565 5.53564C15.082 5.8415 15.082 6.34541 14.7568 6.62666Z"
        fill="#757575"
      />
    </svg>
  ),
  move: (props) => (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.35167 8.3325V11.0417C8.35167 11.385 8.63083 11.6667 8.97833 11.6667C9.135 11.6667 9.29083 11.6075 9.41 11.495C10.8892 10.0908 13.5308 7.585 14.74 6.4375C14.9067 6.28 15 6.06083 15 5.83333C15 5.605 14.9067 5.38667 14.74 5.22917C13.5308 4.08167 10.8892 1.575 9.41 0.1725C9.29083 0.0591665 9.135 0 8.97833 0C8.63083 0 8.35167 0.280833 8.35167 0.625V3.33417H0.835C0.3925 3.33417 0 3.72583 0 4.1675V7.49917C0 7.94083 0.3925 8.3325 0.835 8.3325H8.35167Z"
        fill="#757575"
      />
    </svg>
  ),
  selectFile: (props) => (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.49804 12H1.1956C1.1956 12 1.5626 10.0344 1.5121 9.15688C1.4916 8.79487 1.4316 8.41985 1.2421 8.10484C0.919603 7.60482 -0.0758863 6.24476 0.00461285 4.38968C0.116612 1.78507 2.35109 0 5.06756 0C7.61654 0 9.32102 1.50056 9.99651 3.74166C10.1605 4.28118 10.152 4.51219 9.92101 5.04521L9.91801 5.05171L10.7935 6.12276C10.9235 6.31326 11 6.51827 11 6.74228C11 7.01579 10.8835 7.2648 10.695 7.44181C10.511 7.61432 10.3115 7.66782 10.071 7.76282C10.071 7.76282 9.78301 9.05888 9.63451 9.40839C9.28452 10.2299 8.64952 10.2379 8.14953 10.3329C7.95253 10.3744 7.90453 10.3994 7.80903 10.6734C7.70503 10.969 7.62754 11.391 7.49804 12ZM5.07706 0.999542C2.93458 1.02354 1.2071 2.27359 1.0166 4.24368C0.920603 5.23922 1.2481 6.23676 1.77459 7.0963C2.08009 7.59632 2.42709 7.89233 2.50659 9.03388C2.55209 9.6904 2.48159 10.3519 2.38609 11H6.68805C6.75854 10.6774 6.86304 10.2574 7.03154 9.97141C7.25604 9.5884 7.58004 9.42189 7.99453 9.34439C8.41353 9.27039 8.61352 9.31489 8.73902 8.95187C8.84502 8.66236 9.04502 7.84133 9.15452 7.00079C9.75601 6.83328 9.46052 6.92029 9.99001 6.72128C9.88701 6.60428 9.03102 5.56423 8.96752 5.42123C8.79952 5.04171 8.94452 4.8262 9.08002 4.46469C9.12302 4.33918 9.11002 4.28618 9.07552 4.15817C8.55102 2.18359 7.13004 0.999542 5.07706 0.999542ZM5.33706 2.4996C5.45806 2.84162 5.49306 3.06063 5.75755 3.17013C6.02255 3.28064 6.20455 3.14813 6.52955 2.99362L7.00604 3.46964C6.85004 3.79716 6.71954 3.97767 6.82904 4.24168C6.93854 4.50569 7.15554 4.54069 7.50004 4.66269V5.33622C7.15954 5.45773 6.93854 5.49273 6.82904 5.75774C6.71904 6.02225 6.85054 6.20326 7.00604 6.52977L6.52955 7.00579C6.20105 6.84929 6.02255 6.71878 5.75905 6.82828C5.49356 6.93929 5.45806 7.1588 5.33706 7.49981H4.66307C4.54207 7.1578 4.50707 6.93879 4.24257 6.82978L4.24207 6.82928C3.97757 6.71878 3.79607 6.85079 3.47008 7.00579L2.99408 6.52977C3.14658 6.20826 3.28108 6.02425 3.17058 5.75724C3.06058 5.49273 2.84008 5.45773 2.50009 5.33622V4.66269C2.84058 4.54169 3.06058 4.50669 3.17058 4.24218C3.28058 3.97667 3.14958 3.79666 2.99408 3.46964L3.47008 2.99362C3.79857 3.14963 3.97757 3.28014 4.24207 3.17013C4.50657 3.06063 4.54207 2.83962 4.66307 2.4996H5.33706ZM5.00006 5.83324C4.54007 5.83324 4.16657 5.46023 4.16657 4.99971C4.16657 4.53919 4.54007 4.16617 5.00006 4.16617C5.46006 4.16617 5.83305 4.53919 5.83305 4.99971C5.83305 5.46023 5.46006 5.83324 5.00006 5.83324Z"
        fill="#757575"
      />
    </svg>
  ),
  upload: (props) => (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.66133 5.74047L6.99467 7.76568L6.50333 7.3182L8.99467 4.30484L11.4967 7.33538L10.9947 7.77493L9.328 5.74179V10.9145H8.66133V5.74047ZM13.3333 12.2365H4.66667C3.01267 12.2365 1.66667 10.9026 1.66667 9.26211C1.66667 7.82252 2.70333 6.59312 4.132 6.33798L4.65133 6.24545L4.68 5.72394C4.80333 3.44492 6.70067 1.66097 9 1.66097C11.2993 1.66097 13.1967 3.44492 13.3187 5.72394L13.348 6.24545L13.868 6.33798C15.296 6.59312 16.3333 7.82252 16.3333 9.26211C16.3333 10.9026 14.9873 12.2365 13.3333 12.2365ZM13.9853 5.68759C13.844 3.0761 11.6707 1 9 1C6.32933 1 4.15533 3.0761 4.014 5.68759C2.30067 5.99362 1 7.47617 1 9.26211C1 11.2695 2.642 12.8974 4.66667 12.8974H13.3333C15.358 12.8974 17 11.2695 17 9.26211C17 7.47617 15.6993 5.99362 13.9853 5.68759Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
    </svg>
  ),
  plus: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.3 1V13.6M1 7.3H13.6"
        stroke="#303030"
        stroke-width="1.35"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  table: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.833333 0C0.435 0 0 0.315833 0 0.833333V14.1667C0 14.6833 0.4325 15 0.833333 15H14.1667C14.6842 15 15 14.5667 15 14.1667V0.833333C15 0.435 14.6842 0 14.1667 0H0.833333ZM6.875 13.75H1.25V8.125H6.875V13.75ZM13.75 8.125V13.75H8.125V8.125H13.75ZM13.75 1.25V6.875H8.125V1.25H13.75ZM1.25 1.25H6.875V6.875H1.25V1.25Z"
        fill="#757575"
      />
    </svg>
  ),
  uploadFile: (props) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1177_10233)">
        <path
          d="M5.83325 5.25H2.33325L6.99992 0L11.6666 5.25H8.16658V11.6667H5.83325V5.25ZM12.2499 11.6667V12.8333H1.74992V11.6667H0.583252V14H13.4166V11.6667H12.2499Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_1177_10233">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  pdf: (props) => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.363 2C13.518 2 12 8 12 8C12 8 18 6.35 18 10.457V22H2V2H9.363ZM10.189 0H0V24H20V9.614C20 7.223 13.352 0 10.189 0ZM15 13H12.372V16.686H13.279V15.214H14.769V14.482H13.279V13.784H15V13ZM10.1 13H8.501V16.686H10.1C10.637 16.686 11.061 16.505 11.362 16.151C11.917 15.493 11.949 14.117 11.3 13.459C11.002 13.159 10.588 13 10.1 13ZM9.408 13.783H9.904C10.377 13.783 10.706 13.956 10.819 14.427C10.883 14.694 10.896 15.106 10.798 15.375C10.67 15.726 10.417 15.903 10.044 15.903H9.407V13.783H9.408ZM6.668 13H5V16.686H5.907V15.409H6.668C7.287 15.409 7.732 15.132 7.892 14.646C7.987 14.355 7.987 14.049 7.892 13.761C7.732 13.277 7.286 13 6.668 13ZM5.907 13.732H6.453C6.688 13.732 6.92 13.76 7.029 13.96C7.096 14.083 7.096 14.326 7.029 14.449C6.92 14.648 6.688 14.676 6.453 14.676H5.907V13.732Z"
        fill="black"
      />
    </svg>
  ),
  filePdf: (props) => (
    <svg
      width="20"
      height="25"
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M13.9664 5.4248C13.4197 5.42427 12.8956 5.20685 12.509 4.82028C12.1224 4.43371 11.905 3.90956 11.9045 3.36287V0.5H2.69089C1.97722 0.5 1.29278 0.783511 0.788145 1.28815C0.283505 1.79279 0 2.47721 0 3.19088V19.4122C0.00105979 20.1252 0.28503 20.8086 0.789555 21.3124C1.29408 21.8161 1.97791 22.0991 2.69089 22.0991H13.7514C14.4644 22.0991 15.1482 21.8161 15.6528 21.3124C16.1573 20.8086 16.4413 20.1252 16.4423 19.4122V5.4248H13.9664Z"
          fill="#5B5B5B"
        />
      </g>
      <path
        d="M16.4421 5.4248H13.9662C13.4195 5.42427 12.8954 5.20685 12.5088 4.82028C12.1222 4.43371 11.9048 3.90956 11.9043 3.36287V0.5L16.4421 5.4248Z"
        fill="#5B5B5B"
      />
      <path
        d="M13.0599 15.583H2.73631C2.63686 15.583 2.54148 15.5434 2.47116 15.4731C2.40083 15.4028 2.36133 15.3074 2.36133 15.208C2.36159 15.1087 2.40122 15.0136 2.47151 14.9435C2.5418 14.8733 2.63703 14.834 2.73631 14.834H13.0599C13.1591 14.834 13.2542 14.8734 13.3243 14.9435C13.3945 15.0136 13.4339 15.1088 13.4339 15.208C13.434 15.2572 13.4244 15.3059 13.4057 15.3514C13.387 15.3969 13.3594 15.4382 13.3247 15.473C13.2899 15.5079 13.2487 15.5355 13.2032 15.5544C13.1578 15.5732 13.1091 15.583 13.0599 15.583Z"
        fill="#5B5B5B"
      />
      <path
        d="M13.0599 11.3593H2.73631C2.63703 11.3593 2.5418 11.3199 2.47151 11.2498C2.40122 11.1797 2.36159 11.0846 2.36133 10.9853C2.36133 10.8859 2.40083 10.7905 2.47116 10.7202C2.54148 10.6498 2.63686 10.6104 2.73631 10.6104H13.0599C13.1091 10.6104 13.1578 10.6201 13.2032 10.6389C13.2487 10.6578 13.2899 10.6854 13.3247 10.7202C13.3594 10.7551 13.387 10.7964 13.4057 10.8419C13.4244 10.8874 13.434 10.9361 13.4339 10.9853C13.4339 11.0845 13.3945 11.1796 13.3243 11.2498C13.2542 11.3199 13.1591 11.3593 13.0599 11.3593Z"
        fill="#5B5B5B"
      />
      <path
        d="M13.0599 13.4716H2.73631C2.63686 13.4716 2.54148 13.4321 2.47116 13.3618C2.40083 13.2915 2.36133 13.1961 2.36133 13.0966C2.36159 12.9974 2.40122 12.9022 2.47151 12.8321C2.5418 12.762 2.63703 12.7227 2.73631 12.7227H13.0599C13.1591 12.7227 13.2542 12.7621 13.3243 12.8322C13.3945 12.9023 13.4339 12.9975 13.4339 13.0966C13.434 13.1458 13.4244 13.1946 13.4057 13.2401C13.387 13.2856 13.3594 13.3269 13.3247 13.3617C13.2899 13.3966 13.2487 13.4242 13.2032 13.4431C13.1578 13.4619 13.1091 13.4716 13.0599 13.4716Z"
        fill="#5B5B5B"
      />
      <path
        d="M8.98805 9.24799H2.73631C2.63703 9.24799 2.5418 9.20863 2.47151 9.13852C2.40122 9.06842 2.36159 8.97329 2.36133 8.87401C2.36133 8.77456 2.40083 8.67918 2.47116 8.60886C2.54148 8.53853 2.63686 8.49902 2.73631 8.49902H8.98805C9.08733 8.49929 9.18246 8.5389 9.25256 8.6092C9.32267 8.67949 9.36204 8.77473 9.36204 8.87401C9.36177 8.97311 9.32229 9.06808 9.25221 9.13816C9.18213 9.20824 9.08716 9.24773 8.98805 9.24799Z"
        fill="#5B5B5B"
      />
      <path
        d="M8.98805 7.13569H2.73631C2.63703 7.13569 2.5418 7.0963 2.47151 7.02619C2.40122 6.95609 2.36159 6.86098 2.36133 6.7617C2.36133 6.66225 2.40083 6.56685 2.47116 6.49653C2.54148 6.42621 2.63686 6.38672 2.73631 6.38672H8.98805C9.08733 6.38698 9.18246 6.4266 9.25256 6.49689C9.32267 6.56719 9.36204 6.66242 9.36204 6.7617C9.36177 6.86081 9.32229 6.95577 9.25221 7.02585C9.18213 7.09593 9.08716 7.13542 8.98805 7.13569Z"
        fill="#5B5B5B"
      />
      <path
        d="M18.3926 17.5605H5.88914C5.0022 17.5605 4.2832 18.2795 4.2832 19.1665V22.8943C4.2832 23.7813 5.0022 24.5003 5.88914 24.5003H18.3926C19.2795 24.5003 19.9986 23.7813 19.9986 22.8943V19.1665C19.9986 18.2795 19.2795 17.5605 18.3926 17.5605Z"
        fill="#5B5B5B"
      />
      <path
        d="M8.38478 21.8369V22.5639H7.63281V21.8369H8.38478Z"
        fill="white"
      />
      <path
        d="M9.4926 21.5095V22.5645H8.76562V19.5576H9.94358C10.3006 19.5576 10.5736 19.6466 10.7605 19.8236C10.8552 19.9166 10.929 20.0285 10.9773 20.1521C11.0255 20.2757 11.0471 20.4081 11.0405 20.5406C11.0442 20.7154 11.001 20.888 10.9155 21.0405C10.8282 21.1897 10.6988 21.3097 10.5436 21.3855C10.3563 21.4741 10.1506 21.5169 9.94358 21.5105L9.4926 21.5095ZM10.3006 20.5406C10.3006 20.2739 10.1546 20.1406 9.86258 20.1406H9.4926V20.9236H9.86258C10.1546 20.9262 10.3006 20.7985 10.3006 20.5406Z"
        fill="white"
      />
      <path
        d="M13.9133 21.8391C13.7881 22.0665 13.599 22.2521 13.3694 22.3731C13.111 22.5054 12.8236 22.571 12.5334 22.5641H11.3984V19.5572H12.5334C12.8238 19.5499 13.1116 19.6141 13.3714 19.7442C13.6004 19.8625 13.789 20.0463 13.9133 20.2722C14.0434 20.5119 14.1089 20.7814 14.1033 21.0541C14.1087 21.3278 14.0433 21.5982 13.9133 21.8391ZM13.1314 21.6881C13.2127 21.6047 13.2756 21.5052 13.3163 21.396C13.3569 21.2868 13.3743 21.1704 13.3674 21.0541C13.3743 20.938 13.357 20.8217 13.3163 20.7127C13.2757 20.6037 13.2127 20.5044 13.1314 20.4212C12.9495 20.2616 12.7119 20.1803 12.4704 20.1952H12.1254V21.9131H12.4704C12.7117 21.9278 12.9491 21.8469 13.1314 21.6881Z"
        fill="white"
      />
      <path
        d="M16.4746 19.5576V20.1366H15.2416V20.7956H16.1936V21.3485H15.2416V22.5645H14.5137V19.5576H16.4746Z"
        fill="white"
      />
      <path
        d="M12.8767 6.38672H11.1088C10.8006 6.38672 10.5508 6.63653 10.5508 6.9447V8.71262C10.5508 9.02078 10.8006 9.2706 11.1088 9.2706H12.8767C13.1848 9.2706 13.4347 9.02078 13.4347 8.71262V6.9447C13.4347 6.63653 13.1848 6.38672 12.8767 6.38672Z"
        fill="#5B5B5B"
      />
    </svg>
  ),
  img: (props) => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.363 2C13.518 2 12 8 12 8C12 8 18 6.35 18 10.457V22H2V2H9.363ZM10.189 0H0V24H20V9.614C20 7.223 13.352 0 10.189 0Z"
        fill="black"
      />
      <text x="4" y="18" font-family="Arial" font-size="5" fill="black">
        Media
      </text>
    </svg>
  ),
  file: (props) => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.363 2C13.518 2 12 8 12 8C12 8 18 6.35 18 10.457V22H2V2H9.363ZM10.189 0H0V24H20V9.614C20 7.223 13.352 0 10.189 0Z"
        fill="black"
      />

      <text x="5" y="18" font-family="Arial" font-size="6" fill="black">
        File
      </text>
    </svg>
  ),
  chatDownArrow: () => (
    <svg
      width="8"
      height="17"
      viewBox="0 0 8 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.64645 16.3536C3.84171 16.5488 4.15829 16.5488 4.35355 16.3536L7.53553 13.1716C7.7308 12.9763 7.7308 12.6597 7.53553 12.4645C7.34027 12.2692 7.02369 12.2692 6.82843 12.4645L4 15.2929L1.17157 12.4645C0.976311 12.2692 0.659728 12.2692 0.464466 12.4645C0.269204 12.6597 0.269204 12.9763 0.464466 13.1716L3.64645 16.3536ZM3.5 0L3.5 16H4.5L4.5 0L3.5 0Z"
        fill="#1D1D1D"
      />
    </svg>
  ),

  new_copy: () => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.95898 11.8747H3.16732C2.74739 11.8747 2.34466 11.7079 2.04773 11.4109C1.7508 11.114 1.58398 10.7113 1.58398 10.2913V3.16634C1.58398 2.74641 1.7508 2.34369 2.04773 2.04676C2.34466 1.74982 2.74739 1.58301 3.16732 1.58301H10.2923C10.7122 1.58301 11.115 1.74982 11.4119 2.04676C11.7088 2.34369 11.8757 2.74641 11.8757 3.16634V3.95801M8.70898 7.12467H15.834C16.7084 7.12467 17.4173 7.83356 17.4173 8.70801V15.833C17.4173 16.7075 16.7084 17.4163 15.834 17.4163H8.70898C7.83453 17.4163 7.12565 16.7075 7.12565 15.833V8.70801C7.12565 7.83356 7.83453 7.12467 8.70898 7.12467Z"
        stroke="#757575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  new_table: () => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 2.375H3.95833C3.53841 2.375 3.13568 2.54181 2.83875 2.83875C2.54181 3.13568 2.375 3.53841 2.375 3.95833V7.125M7.125 2.375H15.0417C15.4616 2.375 15.8643 2.54181 16.1613 2.83875C16.4582 3.13568 16.625 3.53841 16.625 3.95833V7.125M7.125 2.375V16.625M2.375 7.125V15.0417C2.375 15.4616 2.54181 15.8643 2.83875 16.1613C3.13568 16.4582 3.53841 16.625 3.95833 16.625H7.125M2.375 7.125H16.625M16.625 7.125V15.0417C16.625 15.4616 16.4582 15.8643 16.1613 16.1613C15.8643 16.4582 15.4616 16.625 15.0417 16.625H7.125"
        stroke="#757575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  download_icon: () => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.625 11.875V15.0417C16.625 15.4616 16.4582 15.8643 16.1613 16.1613C15.8643 16.4582 15.4616 16.625 15.0417 16.625H3.95833C3.53841 16.625 3.13568 16.4582 2.83875 16.1613C2.54181 15.8643 2.375 15.4616 2.375 15.0417V11.875M5.54167 7.91667L9.5 11.875M9.5 11.875L13.4583 7.91667M9.5 11.875V2.375"
        stroke="#757575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  speaker_icon: () => (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4102 3.90332C16.8944 5.38791 17.7281 7.40119 17.7281 9.5004C17.7281 11.5996 16.8944 13.6129 15.4102 15.0975M12.6157 6.6979C13.3577 7.4402 13.7746 8.44684 13.7746 9.49645C13.7746 10.5461 13.3577 11.5527 12.6157 12.295M9.02148 3.95874L5.06315 7.1254H1.89648V11.8754H5.06315L9.02148 15.0421V3.95874Z"
        stroke="#757575"
        stroke-width="1.11765"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  export_icon: () => (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.88565 0.377076C2.9604 0.376849 3.03515 0.376591 3.1099 0.376305C3.31202 0.375638 3.51414 0.375458 3.71627 0.375409C3.84261 0.375355 3.96896 0.375193 4.09531 0.374992C4.53624 0.374292 4.97718 0.373981 5.41812 0.374041C5.82899 0.374087 6.23986 0.373285 6.65073 0.372089C7.00385 0.371099 7.35697 0.370691 7.71009 0.37074C7.92085 0.370759 8.1316 0.370543 8.34236 0.369741C8.54037 0.369008 8.73836 0.369 8.93637 0.369553C9.00901 0.369632 9.08166 0.369452 9.1543 0.368995C9.25348 0.36841 9.35261 0.368761 9.45179 0.369346C9.49487 0.368761 9.49487 0.368761 9.53883 0.368164C9.80827 0.371674 9.96079 0.497702 10.1441 0.681192C10.1718 0.70872 10.1995 0.736248 10.228 0.76461C10.2576 0.794428 10.2872 0.824246 10.3177 0.854968C10.3654 0.902511 10.3654 0.902511 10.414 0.951015C10.5006 1.03749 10.587 1.12413 10.6733 1.21085C10.7639 1.3017 10.8546 1.39234 10.9453 1.48302C11.0973 1.63513 11.2493 1.7874 11.4011 1.93975C11.5767 2.11597 11.7525 2.29199 11.9285 2.46789C12.1159 2.65529 12.3032 2.84283 12.4904 3.03041C12.5444 3.08446 12.5984 3.13848 12.6524 3.19249C12.7527 3.29295 12.853 3.39352 12.9532 3.49414C12.9832 3.52411 13.0132 3.55408 13.0441 3.58496C13.0712 3.61228 13.0984 3.63959 13.1264 3.66773C13.1501 3.69151 13.1738 3.71528 13.1982 3.73977C13.2947 3.84483 13.2962 3.919 13.2978 4.05786C13.2982 4.09582 13.2987 4.13378 13.2992 4.1729C13.2997 4.23467 13.2997 4.23467 13.3001 4.29769C13.3004 4.33995 13.3007 4.38221 13.301 4.42576C13.3015 4.51536 13.3019 4.60496 13.3022 4.69457C13.3029 4.83143 13.3046 4.96826 13.3062 5.10511C13.3066 5.19212 13.3069 5.27914 13.3072 5.36615C13.3079 5.40703 13.3085 5.4479 13.3092 5.49001C13.3085 5.72126 13.2966 5.86123 13.1394 6.03601C12.9986 6.10641 12.8379 6.09609 12.6846 6.07392C12.5775 5.9909 12.5172 5.92873 12.4571 5.80858C12.4538 5.70903 12.4527 5.6105 12.4534 5.51096C12.4535 5.46695 12.4535 5.46695 12.4536 5.42205C12.4538 5.3282 12.4543 5.23435 12.4548 5.1405C12.4549 5.07693 12.4551 5.01335 12.4553 4.94978C12.4557 4.79382 12.4564 4.63785 12.4571 4.48189C12.4029 4.48227 12.4029 4.48227 12.3476 4.48265C12.0068 4.48496 11.6661 4.48666 11.3253 4.48778C11.1501 4.48837 10.9749 4.48918 10.7997 4.49047C10.6306 4.4917 10.4615 4.49238 10.2924 4.49268C10.2279 4.49289 10.1635 4.4933 10.099 4.49391C10.0086 4.49474 9.91823 4.49485 9.82785 4.4948C9.80124 4.49521 9.77463 4.49561 9.74721 4.49604C9.58164 4.49499 9.48114 4.46788 9.34887 4.36817C9.32865 4.35411 9.30842 4.34005 9.28759 4.32557C9.20557 4.21432 9.2203 4.09602 9.22225 3.96318C9.22223 3.93358 9.22221 3.90399 9.2222 3.8735C9.22228 3.77566 9.22316 3.67784 9.22405 3.58C9.22426 3.51218 9.22443 3.44435 9.22454 3.37652C9.22497 3.19799 9.22609 3.01946 9.22735 2.84092C9.22851 2.65875 9.22903 2.47657 9.2296 2.2944C9.23082 1.93693 9.23277 1.57947 9.23516 1.22201C8.34221 1.22519 7.44926 1.2288 6.55632 1.23291C6.14169 1.23481 5.72706 1.23657 5.31243 1.238C4.95096 1.23925 4.58949 1.24076 4.22802 1.24259C4.0367 1.24354 3.84538 1.24437 3.65406 1.24488C3.47379 1.24537 3.29353 1.24621 3.11327 1.24731C3.04729 1.24765 2.98131 1.24787 2.91533 1.24795C2.17241 1.24359 2.17241 1.24359 1.53989 1.59574C1.29312 1.86268 1.19466 2.13641 1.1942 2.4998C1.19406 2.54325 1.19391 2.5867 1.19376 2.63147C1.19379 2.67904 1.19383 2.72661 1.19386 2.77561C1.19376 2.82679 1.19365 2.87797 1.19352 2.92914C1.19321 3.06974 1.19314 3.21034 1.19312 3.35093C1.19305 3.50258 1.19276 3.65424 1.1925 3.80589C1.19199 4.13749 1.19176 4.46909 1.19159 4.80069C1.19149 5.00778 1.19133 5.21488 1.19116 5.42197C1.1907 5.99548 1.19031 6.56898 1.19018 7.14248C1.19017 7.17918 1.19016 7.21588 1.19015 7.2537C1.19014 7.29048 1.19014 7.32727 1.19013 7.36517C1.19011 7.43971 1.19009 7.51426 1.19008 7.5888C1.19007 7.62577 1.19006 7.66275 1.19005 7.70085C1.1899 8.29989 1.18924 8.89893 1.18836 9.49798C1.18746 10.1132 1.18699 10.7283 1.18694 11.3435C1.18691 11.6889 1.18669 12.0342 1.186 12.3796C1.18542 12.6736 1.18522 12.9677 1.18554 13.2618C1.18568 13.4118 1.18565 13.5618 1.18512 13.7117C1.18463 13.8492 1.18468 13.9867 1.18514 14.1241C1.18525 14.1971 1.1848 14.27 1.18433 14.3429C1.1867 14.7596 1.25605 15.086 1.54033 15.3987C1.86521 15.7148 2.2744 15.7456 2.70532 15.7449C2.74181 15.745 2.7783 15.7451 2.81589 15.7452C2.93781 15.7454 3.05973 15.7454 3.18164 15.7453C3.2692 15.7455 3.35676 15.7456 3.44432 15.7457C3.68194 15.7461 3.91955 15.7461 4.15717 15.7462C4.30568 15.7462 4.4542 15.7463 4.60271 15.7464C5.09426 15.7467 5.5858 15.7469 6.07735 15.7469C6.11705 15.7469 6.11705 15.7469 6.15756 15.7469C6.19732 15.7469 6.19732 15.7469 6.23788 15.7469C6.66729 15.7468 7.09671 15.7472 7.52613 15.7477C7.96758 15.7483 8.40904 15.7485 8.85049 15.7485C9.09812 15.7485 9.34575 15.7486 9.59338 15.749C9.82632 15.7494 10.0593 15.7494 10.2922 15.7491C10.3776 15.7491 10.4629 15.7491 10.5483 15.7494C10.6651 15.7497 10.7818 15.7495 10.8986 15.7492C10.9322 15.7494 10.9657 15.7496 11.0002 15.7498C11.4256 15.7475 11.7897 15.6665 12.1105 15.372C12.3335 15.1276 12.4233 14.8495 12.4246 14.5204C12.4249 14.4823 12.4251 14.4443 12.4254 14.405C12.4256 14.344 12.4256 14.344 12.4259 14.2817C12.4268 14.195 12.4277 14.1084 12.4286 14.0218C12.43 13.8855 12.4311 13.7493 12.4316 13.613C12.4322 13.4813 12.4337 13.3496 12.4354 13.2179C12.4353 13.1772 12.4352 13.1365 12.4351 13.0946C12.4398 12.8115 12.4398 12.8115 12.5299 12.6644C12.6447 12.5614 12.7157 12.5237 12.8694 12.5036C13.0198 12.5217 13.0976 12.5759 13.2152 12.6695C13.2989 12.795 13.3007 12.8342 13.3015 12.9803C13.3018 13.0205 13.3022 13.0608 13.3026 13.1023C13.3025 13.1677 13.3025 13.1677 13.3025 13.2344C13.3026 13.2794 13.3028 13.3244 13.3029 13.3708C13.3032 13.4664 13.3032 13.562 13.303 13.6575C13.3029 13.8025 13.3038 13.9475 13.3047 14.0925C13.3048 14.1855 13.3049 14.2785 13.3048 14.3715C13.3052 14.4144 13.3055 14.4573 13.3059 14.5015C13.3024 15.1065 13.1176 15.5919 12.7004 16.0321C12.238 16.4698 11.7012 16.6239 11.0761 16.6218C11.0381 16.622 11.0001 16.6221 10.961 16.6223C10.8347 16.6228 10.7085 16.6227 10.5822 16.6227C10.4913 16.6229 10.4003 16.6232 10.3094 16.6234C10.0885 16.624 9.8677 16.6243 9.64686 16.6243C9.46714 16.6244 9.28742 16.6245 9.1077 16.6248C8.597 16.6254 8.0863 16.6258 7.57561 16.6257C7.54813 16.6257 7.52065 16.6257 7.49234 16.6257C7.45107 16.6257 7.45107 16.6257 7.40896 16.6257C6.96352 16.6257 6.51809 16.6264 6.07266 16.6275C5.61415 16.6286 5.15565 16.6291 4.69714 16.629C4.44018 16.629 4.18323 16.6292 3.92627 16.63C3.68439 16.6307 3.44253 16.6307 3.20065 16.6302C3.11228 16.6301 3.0239 16.6303 2.93552 16.6308C2.17219 16.6345 1.48598 16.5824 0.900677 16.0312C0.549016 15.6554 0.323012 15.1655 0.322374 14.647C0.322228 14.6026 0.322082 14.5581 0.321932 14.5123C0.321965 14.4636 0.321998 14.4149 0.322032 14.3648C0.321934 14.3124 0.32182 14.26 0.321691 14.2076C0.321385 14.0637 0.321317 13.9198 0.321289 13.7759C0.321219 13.6207 0.320933 13.4655 0.320677 13.3103C0.320163 12.9708 0.319934 12.6314 0.319767 12.2919C0.319662 12.0799 0.319502 11.8679 0.319331 11.6559C0.318869 11.0687 0.318478 10.4814 0.31835 9.8942C0.318342 9.85662 0.318334 9.81904 0.318325 9.78032C0.318317 9.74265 0.318309 9.70498 0.3183 9.66617C0.318283 9.58984 0.318266 9.51351 0.318249 9.43718C0.318241 9.39931 0.318232 9.36145 0.318224 9.32244C0.318074 8.70923 0.317413 8.09602 0.31653 7.48281C0.31563 6.85298 0.315159 6.22314 0.315114 5.59331C0.31508 5.23979 0.314863 4.88627 0.314174 4.53275C0.313589 4.23165 0.313396 3.93055 0.313709 3.62944C0.313857 3.47592 0.313823 3.32241 0.31329 3.16889C0.312805 3.0281 0.312854 2.88731 0.313312 2.74652C0.313421 2.67199 0.312973 2.59745 0.3125 2.52292C0.315909 1.90662 0.491786 1.4174 0.918001 0.967629C1.49342 0.422884 2.1336 0.37662 2.88565 0.377076ZM10.0691 1.86641C10.0691 2.45432 10.0691 3.04223 10.0691 3.64797C10.657 3.64797 11.2449 3.64797 11.8506 3.64797C11.6596 3.42479 11.6596 3.42479 11.4588 3.21332C11.4286 3.18298 11.3984 3.15265 11.3672 3.12139C11.3354 3.0896 11.3035 3.0578 11.2707 3.02504C11.2374 2.99176 11.2042 2.95848 11.1699 2.9242C11.1001 2.85435 11.0302 2.78456 10.9603 2.71481C10.8885 2.64315 10.8168 2.57144 10.7452 2.49963C10.6417 2.3959 10.538 2.2923 10.4344 2.18875C10.4021 2.15642 10.3699 2.12408 10.3366 2.09077C10.307 2.06127 10.2774 2.03177 10.2469 2.00138C10.2207 1.97524 10.1945 1.94911 10.1676 1.92218C10.1161 1.86213 10.1161 1.86213 10.0691 1.86641Z"
        fill="#757575"
      />
      <path
        d="M10.4343 6.05517C10.4808 6.05106 10.4808 6.05106 10.5282 6.04688C10.8795 6.13398 11.2138 6.60567 11.4658 6.85755C11.5162 6.9078 11.5665 6.95805 11.6169 7.0083C11.7219 7.11308 11.8268 7.21794 11.9317 7.32285C12.0661 7.45725 12.2008 7.5914 12.3355 7.72548C12.4394 7.82892 12.5431 7.93253 12.6467 8.03619C12.6963 8.08575 12.746 8.13524 12.7957 8.18467C12.865 8.25361 12.9341 8.32278 13.0031 8.39201C13.0339 8.42247 13.0339 8.42247 13.0653 8.45354C13.214 8.60355 13.2815 8.69918 13.3128 8.90756C13.2992 9.27514 12.7479 9.65638 12.4997 9.90465C12.4486 9.95588 12.3975 10.0071 12.3464 10.0583C12.2399 10.1651 12.1332 10.2718 12.0265 10.3785C11.8898 10.5152 11.7534 10.6522 11.617 10.7892C11.5118 10.8948 11.4065 11.0003 11.301 11.1056C11.2506 11.1561 11.2003 11.2066 11.15 11.2572C11.0799 11.3277 11.0096 11.3979 10.9391 11.4681C10.9185 11.489 10.8978 11.5098 10.8765 11.5313C10.741 11.6658 10.6435 11.7494 10.4533 11.7742C10.3028 11.7561 10.2251 11.7019 10.1074 11.6083C10.0273 11.4882 10.0203 11.4175 10.0141 11.2759C10.072 10.9958 10.353 10.7845 10.5463 10.5935C10.5814 10.5585 10.6165 10.5234 10.6527 10.4874C10.7455 10.3948 10.8385 10.3026 10.9316 10.2103C11.0268 10.1159 11.1218 10.0213 11.2167 9.92671C11.4027 9.74156 11.5889 9.55666 11.7752 9.3719C11.743 9.37181 11.7107 9.37172 11.6775 9.37163C10.8929 9.36939 10.1084 9.36652 9.32381 9.36297C8.9444 9.36126 8.565 9.35977 8.18559 9.35877C7.85492 9.3579 7.52426 9.35663 7.1936 9.35489C7.01849 9.35399 6.84338 9.35328 6.66827 9.35304C6.50347 9.35281 6.33867 9.35205 6.17387 9.35089C6.11338 9.35056 6.05288 9.35042 5.99239 9.35048C5.90978 9.35055 5.8272 9.34992 5.74459 9.34911C5.67525 9.34885 5.67525 9.34885 5.60451 9.34858C5.44159 9.32904 5.34503 9.26658 5.22469 9.15868C5.15412 9.01755 5.15408 8.88195 5.17968 8.72751C5.24768 8.61871 5.29274 8.55726 5.40711 8.50007C5.49114 8.49604 5.5753 8.49451 5.65943 8.49408C5.69876 8.4938 5.69876 8.4938 5.73889 8.49351C5.82719 8.49293 5.91548 8.49261 6.00377 8.49229C6.0669 8.49193 6.13002 8.49155 6.19314 8.49115C6.36488 8.49013 6.53662 8.48933 6.70836 8.48858C6.8877 8.48775 7.06704 8.48671 7.24638 8.48569C7.58616 8.4838 7.92593 8.4821 8.26571 8.48046C8.65246 8.47859 9.03921 8.47651 9.42596 8.47441C10.2217 8.47009 11.0174 8.46604 11.8131 8.46217C11.7914 8.44049 11.7696 8.41882 11.7472 8.39648C11.5424 8.19244 11.3377 7.9883 11.1331 7.78406C11.0279 7.67906 10.9226 7.57409 10.8173 7.4692C10.7157 7.36803 10.6142 7.26676 10.5128 7.16542C10.474 7.12673 10.4352 7.08807 10.3964 7.04945C10.3421 6.99545 10.288 6.94132 10.2339 6.88718C10.1875 6.84097 10.1875 6.84097 10.1402 6.79383C10.0273 6.67365 10.019 6.58383 10.0205 6.41927C10.0383 6.29109 10.1022 6.20973 10.1832 6.11203C10.2719 6.06767 10.3354 6.06129 10.4343 6.05517Z"
        fill="#757575"
      />
    </svg>
  ),
  clockIcon: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2839_972)">
        <path
          d="M9.99935 4.99984V9.99984L13.3327 11.6665M18.3327 9.99984C18.3327 14.6022 14.6017 18.3332 9.99935 18.3332C5.39698 18.3332 1.66602 14.6022 1.66602 9.99984C1.66602 5.39746 5.39698 1.6665 9.99935 1.6665C14.6017 1.6665 18.3327 5.39746 18.3327 9.99984Z"
          stroke="#757575"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2839_972">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  animatedSparkels: () => (
    <svg
      class="stars"
      width="20"
      height="20"
      viewBox="0 0 200 200"
      xmlns="SVG namespace "
      fill="#1D1D1D"
    >
      <path
        class="star"
        d="M55 47C55.66 47 56.32 47 57 47C57.4009 48.0042 57.8018 49.0084 58.2148 50.043C67.6211 72.9476 82.9741 89.8634 105.875 99.5625C107.911 100.388 109.951 101.206 112 102C112 102.66 112 103.32 112 104C110.892 104.437 110.892 104.437 109.762 104.883C85.6574 114.623 70.0162 128.677 59.4961 152.445C57.9988 155.876 57.9988 155.876 57 159C56.34 159 55.68 159 55 159C54.6597 158.056 54.3194 157.113 53.9688 156.141C46.0805 134.961 31.69 117.627 11 108C7.38958 106.491 3.75354 105.116 0 104C0 103.34 0 102.68 0 102C1.01578 101.588 2.03156 101.175 3.07812 100.75C12.0673 97.014 20.1656 92.8699 28 87C28.7141 86.4702 29.4283 85.9404 30.1641 85.3945C42.1228 75.7465 50.4491 61.5058 55 47Z"
      />
      <path
        class="star"
        d="M149 0C152.087 1.54345 152.296 4.07247 153.5 7.25C160.608 24.8108 174.549 36.6805 191.68 44.1719C193.434 44.8337 195.214 45.4285 197 46C195.545 48.9096 193.637 49.0532 190.625 50.1875C169.728 58.7047 158.754 73.8307 150 94C147.628 91.6283 147.042 89.6999 145.875 86.5625C142.343 77.8686 136.987 70.2885 130 64C129.161 63.1898 129.161 63.1898 128.305 62.3633C123.06 57.4687 117.387 54.2076 111 51C109.772 50.3754 109.772 50.3754 108.52 49.7383C106.686 48.8133 104.844 47.9046 103 47C105.751 44.2495 109.092 42.9618 112.562 41.3125C130.636 32.4494 141.905 18.7171 149 0Z"
      />
      <path
        class="star"
        d="M196 84C198.645 87.3808 200.625 90.8961 202.621 94.6836C205.528 99.567 208.602 102.703 213.438 105.688C214.364 106.269 215.291 106.85 216.246 107.449C218.785 108.879 221.27 109.994 224 111C224 111.66 224 112.32 224 113C223.143 113.424 222.286 113.848 221.402 114.285C208.842 120.728 203.227 127.414 197 140C194.725 137.924 193.462 136.131 192.25 133.312C187.162 122.888 178.65 117.055 168 113C169.467 110.066 171.598 109.703 174.562 108.375C185.749 102.848 190.668 94.9316 196 84Z"
      />
      <path
        class="star"
        d="M135 140C137.714 141.357 137.883 142.793 139.062 145.562C143.294 154.262 150.308 159.207 159 163C158 165 158 165 154.438 166.688C145.089 171.27 140.427 177.727 136 187C133.917 184.292 132.059 181.521 130.25 178.625C125.433 171.4 119.822 167.568 112 164C113.867 162.522 115.733 161.153 117.801 159.969C126.19 155.147 131.09 148.758 135 140Z"
      />
    </svg>
  ),
};

// name: (props) => (),

export default icons;
